/* German dictionary. Falls back to English for missing keys. */
const de = {
  common: {
    upgrade_pro: "Auf Pro upgraden",
    upgrade_premium: "Auf Premium upgraden",
    save_pct: "{pct}% sparen",
    save_eur_yr: "\u20AC{amount}/Jahr sparen",
    cancel: "Abbrechen",
    confirm: "Best\u00E4tigen",
    save: "Speichern",
    saving: "Wird gespeichert\u2026",
    loading: "Wird geladen\u2026",
    learn_more: "Mehr erfahren",
    add: "Hinzuf\u00FCgen",
    none: "Keine",
    done: "Fertig",
    just_now: "gerade eben",
    minutes_ago: "vor {n} Min.",
    hours_ago: "vor {n} Std.",
    days_ago: "vor {n} Tg.",
    months_ago: "vor {n} Mon.",
    back_to_landing: "Zur\u00FCck zur Startseite",
    refresh: "Aktualisieren",
    or: "oder",
    per_month_short: "/Mon.",
    billed_yearly: "Abrechnung \u20AC{amount}/Jahr",
    billed_yearly_short: "Abrechnung \u20AC{amount}/Jahr \u00B7 {pct}% sparen",
    or_yearly_short: "Oder \u20AC{amount}/Jahr ({pct}% sparen)",
    current: "Aktuell",
    current_plan: "Aktueller Plan",
    coming_soon: "Demn\u00E4chst",
    plan: "Plan",
    free_label: "Free",
    pro_label: "Pro",
    premium_label: "Premium",
  },
  language: {
    label: "Sprache",
    english: "English",
    german: "Deutsch",
  },
  nav: {
    analyze: "Analysieren",
    watchlist: "Watchlist",
    portfolio: "Portfolio",
    pricing: "Preise",
    billing_usage: "Abrechnung & Nutzung",
    log_in: "Anmelden",
    log_out: "Abmelden",
    get_started: "Jetzt starten",
    signed_in_as: "Angemeldet als",
    search_placeholder: "Aktien-Ticker suchen",
    ai_badge: "KI",
  },
  footer: {
    tagline: "KI-gest\u00FCtzte Aktienanalyse. Finde unterbewertete Aktien in Sekunden.",
    product: "Produkt",
    legal: "Rechtliches",
    disclaimer: "Haftungsausschluss",
    disclaimer_body: "Diese Plattform bietet ausschließlich Aktienanalysen zu Informations- und Bildungszwecken und stellt keine Anlageberatung dar. Analysen können Markt- und Fundamentaldaten von Financial Modeling Prep verwenden. Daten können je nach Verfügbarkeit verzögert, veraltet, geschätzt oder unvollständig sein.",
    rights: "\u00A9 {year} Stockaily \u00B7 stockaily.ai",
    built_for: "Gebaut f\u00FCr ernsthafte Privatanleger.",
    link_analyze: "Analysieren",
    link_pricing: "Preise",
    link_watchlist: "Watchlist",
    link_portfolio: "Portfolio",
    link_login: "Anmelden",
    link_privacy: "Datenschutzerkl\u00E4rung",
    link_terms: "AGB",
    link_cookies: "Cookie-Richtlinie",
    link_impressum: "Impressum",
  },
  // Phase 8.LP.LR v1.8 — Landing-Seite /analyze.
  analyze_landing: {
    hero_kicker: "AKTIENANALYSE",
    hero_title: "Jede Aktie in Sekunden analysieren",
    hero_body: "Fair Value, AI Opportunity Score, Risiko und KI-Insights in einer klaren, institutionellen Analyse.",
    search_placeholder: "Aktien-Ticker oder Unternehmen suchen",
    preview_label: "Beispiel-Analyse",
    preview_caption: "So sieht eine echte Stockaily-Analyse aus.",
    signal_undervalued: "Unterbewertet",
    signal_fairly_valued: "Fair bewertet",
    signal_overvalued: "\u00DCberbewertet",
    risk_low: "Niedriges Risiko",
    risk_medium: "Mittleres Risiko",
    risk_high: "Hohes Risiko",
    horizon_short: "Kurzfristig",
    horizon_mid: "Mittelfristig",
    horizon_long: "Langfristig",
    live_data_chip: "Live-Daten",
    section_score: "AI Opportunity Score",
    section_score_hint: "Kompositbewertungs-Signal, 0-100.",
    section_snapshot: "Institutioneller Snapshot",
    section_snapshot_hint: "Die Ein-Satz-Einsch\u00E4tzung.",
    section_ai_insights: "KI-Insights",
    section_key_drivers: "Wesentliche Treiber",
    section_chart: "Kurshistorie",
    section_kpis: "Wichtige Kennzahlen",
    ai_summary_title: "Zusammenfassung",
    kd_undervalued_label: "Handelt unter Fair Value",
    kd_positive_growth_label: "Positives Umsatzwachstum",
    kd_healthy_margins_label: "Solide operative Marge",
    kd_reasonable_multiples_label: "Angemessene Bewertungs-Multiples",
    lock_bull_title: "Bull Case",
    lock_bear_title: "Bear Case",
    lock_risks_title: "Wesentliche Risiken",
    lock_confidence_title: "Konfidenz-Analyse",
    lock_alpha_title: "KI Alpha-Signale",
    lock_hint: "Registriere dich, um die vollst\u00E4ndige Analyse freizuschalten.",
    cta_signed_out_title: "Bereit, deine eigenen Aktien zu analysieren?",
    cta_signed_out_body: "Erstelle einen kostenlosen Account und starte deine erste Analyse in Sekunden.",
    cta_signed_out_primary: "Kostenlosen Account erstellen",
    cta_signed_out_secondary: "Preise ansehen",
    cta_signed_in_title: "Frische Analyse starten",
    cta_signed_in_body: "Tippe oben einen Ticker ein oder w\u00E4hle aus deiner Watchlist.",
    cta_signed_in_secondary: "Zur Watchlist",
    kpi_market_cap: "Marktkap.",
    kpi_pe: "KGV",
    kpi_ps: "KUV",
    kpi_pb: "KBV",
    kpi_revenue_growth: "Ums.-Wachstum",
    kpi_operating_margin: "Op. Marge",
    kpi_current_price: "Aktueller Kurs",
    kpi_fair_value: "Fair Value",
    kpi_upside: "Upside",
    snapshot_body: "Handelt moderat unter unserer Fair-Value-Sch\u00E4tzung mit soliden operativen Margen und stetigem Umsatzwachstum. Die Bilanzqualit\u00E4t st\u00FCtzt das aktuelle Risikoprofil.",
    ai_summary_body: "Stockailys Bewertungs-Engine liest die Position aktuell als unterbewertet gegen\u00FCber dem intrinsischen Wert. Der Kompositscore reflektiert solide Fundamentaldaten, angemessene Multiples relativ zu Peers und ein handhabbares Risikoprofil.",
    ai_summary_body_pypl: "PayPal Holdings, Inc. ist im Finanzsektor t\u00E4tig, insbesondere im Bereich Credit Services. Die Aktie wird als 'Value'-Titel klassifiziert mit einem aktuellen Kurs von 44,28, was einer Marktkapitalisierung von ca. 39,06 Milliarden entspricht. Das Unternehmen gilt derzeit als unterbewertet mit einer Fair-Value-Sch\u00E4tzung zwischen 43,46 und 80,91 \u2014 was ein potenzielles Upside von 40,43% suggeriert. Die Fair-Value-Konfidenz ist jedoch niedrig, was auf Unsicherheit in der Bewertung hinweist.",
    locked_strip_title: "Sieh dir die vollst\u00E4ndige institutionelle Analyse an",
    locked_strip_body: "Bull Case, Bear Case, wesentliche Risiken, Konfidenz-Analyse und KI-Alpha-Details schaltest du mit einem kostenlosen Stockaily-Account frei.",
    inline_cta_title: "Kostenlos starten und mehr freischalten",
    inline_cta_subtext: "Starte deine erste Aktienanalyse in Sekunden.",
    inline_cta_body: "Registriere dich, um die vollst\u00E4ndige Analyse freizuschalten.",
    inline_cta_button: "Kostenlosen Account erstellen",
  },
  // Phase 8.LP.LR v1.3 — Analyze Hub (angemeldet).
  analyze_hub: {
    hero_body:
      "Gib einen Ticker ein, um Fair Value, AI Opportunity Score, Risiko und KI-Insights zu sehen.",
    usage_loading: "Plan wird geladen…",
    usage_unlimited: "Unbegrenzte Analysen aktiv",
    usage_analyses_remaining: "Analysen verbleibend",
    usage_first_period: "erste 30 Tage",
    usage_rolling_window: "rollende 30 Tage",
    usage_exhausted: "Du hast alle deine kostenlosen Analysen aufgebraucht.",
    usage_exhausted_link: "Preise ansehen",
    usage_unavailable: "Nutzungsstatus nicht verf\u00FCgbar — du kannst trotzdem unten suchen.",
    recent_title: "Zuletzt analysierte Aktien",
    recent_empty_body:
      "Noch keine Analysen. Suche oben einen Ticker, um deine erste Analyse zu starten.",
    recent_open: "Analyse \u00F6ffnen",
    education_title: "So liest du den AI Opportunity Score",
    education_intro:
      "Kurze Erkl\u00E4rung der vier Kennzahlen, die Stockaily bei jeder Analyse zeigt.",
    education_score_title: "AI Opportunity Score (0–100)",
    education_score_body:
      "Kombiniert Bewertung, Unternehmensqualit\u00E4t, Wachstum und Risiko in einem 0–100 Signal. H\u00F6her bedeutet nicht automatisch 'Kaufen' — es zeigt, dass die Aktie aktuell attraktiver relativ zu Fair Value und Risikoprofil erscheint.",
    education_fairvalue_title: "Fair Value",
    education_fairvalue_body:
      "Stockailys gesch\u00E4tzter innerer Wert pro Aktie, gemischt aus DCF, Sektor-KGV und Buchwert. Vergleiche ihn mit dem aktuellen Kurs, um Upside/Downside zu sehen.",
    education_risk_title: "Risiko",
    education_risk_body:
      "Niedrig / Mittel / Hoch, basierend auf Beta, Bilanzqualit\u00E4t und Fair-Value-Konfidenz. Riskantere Aktien k\u00F6nnen kleinere Positionsgr\u00F6\u00DFen rechtfertigen.",
    concept_fair_value: "Fair Value",
    concept_fair_value_help:
      "Gesch\u00E4tzter innerer Wert pro Aktie. Gemischt aus DCF, Sektor-KGV und KBV je nach Aktientyp.",
    concept_score: "AI Opportunity Score",
    concept_score_help:
      "0–100 Komposit aus Bewertung, Qualit\u00E4t, Wachstum und Risiko. H\u00F6her bedeutet attraktiver relativ zu Fair Value und Risikoprofil.",
    concept_risk: "Risiko",
    concept_risk_help:
      "Niedrig / Mittel / Hoch. Ber\u00FCcksichtigt Beta, Bilanzqualit\u00E4t und Konfidenz in der Fair-Value-Sch\u00E4tzung.",
    concept_bullbear: "Bull / Bear Case",
    concept_bullbear_help:
      "KI-generierte Argumente f\u00FCr und gegen den Kauf, basierend auf Bewertung und Fundamentaldaten.",
    concept_drivers: "Key Drivers",
    concept_drivers_help:
      "Die konkreten Kennzahlen (Cashflow-Rendite, ROIC, Umsatzwachstum, KGV vs Sektor, Verschuldungsgrad, Fair-Value-Konfidenz), die den Score am st\u00E4rksten beeinflussen.",
  },
  activity: {
    // HINWEIS: Die alten `activity.*`-Schlüssel wurden mit dem
    // Hero-ActivityBar entfernt (Landing Polish — Capability-Streifen
    // ersetzt den früheren fabrizierten Live-Statistik-Chip). Der
    // Namespace bleibt bewusst leer erhalten; neue UI darf diese
    // Schlüssel nicht wieder einführen.
  },
  landing: {
    hero_title_l1: "Erhalte den gesch\u00E4tzten Fair Value einer Aktie",
    hero_title_l2: "in weniger als 30 Sekunden.",
    hero_subtitle: "Fair Value, Opportunity Scores und Portfolio Intelligence f\u00FCr ambitionierte Privatanleger. Basierend auf Fundamentaldaten und einer transparenten Methodik statt auf Blackbox-KI.",
    hero_search_placeholder: "Aktien-Ticker suchen (z.B. AAPL, NVDA, GOOGL)",
    hero_cta: "Analysiere deine erste Aktie",
    capability_primary: "Tausende Aktien",
    capability_secondary: "KI-gest\u00FCtzte Analyse mit mehreren Bewertungsmodellen",
    capability_group_aria: "Stockaily Funktionen",
    how_it_works_eyebrow: "SO FUNKTIONIERT\u2019S",
    how_it_works_title: "Von der Aktiensuche zur klareren Investmentthese",
    how_it_works_subtitle: "Verstehe Bewertung, zentrale Treiber und Risiken in drei fokussierten Schritten.",
    how_it_works_step_find_title: "Aktie finden",
    how_it_works_step_find_desc: "Durchsuche Tausende unterst\u00FCtzte Aktien und w\u00E4hle das Unternehmen aus, das du verstehen m\u00F6chtest.",
    how_it_works_step_find_cat: "SUCHE",
    how_it_works_step_value_title: "Bewertung verstehen",
    how_it_works_step_value_desc: "Erkenne aktuellen Kurs, gesch\u00E4tzten Fair Value, Auf- oder Abw\u00E4rtspotenzial und AI Opportunity Score auf einen Blick.",
    how_it_works_step_value_cat: "BEWERTUNG",
    how_it_works_step_conviction_title: "\u00DCberzeugung aufbauen",
    how_it_works_step_conviction_desc: "Erkenne positives und negatives Szenario, zentrale Risiken und die wichtigsten Treiber.",
    how_it_works_step_conviction_cat: "THESE",
    // Landing Polish 2 — Schritt 2 (Bewertung) kuratierte PayPal-Illustration
    hiw_step2_example_marker: "Beispielanalyse",
    hiw_step2_score_label: "AI Opportunity Score",
    hiw_step2_signal_label: "Opportunity-Level \u00B7 Hoch",
    hiw_step2_assessment: "Unterbewertet um 29,8 %",
    hiw_step2_chip_valuation: "Bewertung \u00B7 Unterbewertet",
    hiw_step2_chip_risk: "Risiko \u00B7 Niedrig",
    hiw_step2_current_price_label: "Aktueller Kurs",
    hiw_step2_now_label: "Aktuell",
    hiw_step2_fair_value_label: "Fair Value",
    hiw_step2_range_label: "Spanne",
    hiw_step2_status_upside: "Potenzial",
    hiw_step2_status_risk: "Risiko",
    hiw_step2_status_horizon: "Horizont",
    hiw_step2_risk_low: "Niedrig",
    hiw_step2_graph_now_label: "AKTUELL",
    hiw_step2_graph_fair_value_label: "FAIR VALUE",
    hiw_step2_graph_aria: "Illustrativer Vergleich des aktuellen PayPal-Kurses mit dem gesch\u00E4tzten Fair Value, der eine Aufw\u00E4rtsl\u00FCcke zeigt.",
    // Landing Polish 2 — Schritt 3 (These) Kategorien + Kurzbeispiele
    hiw_step3_bull_case: "Positives Szenario",
    hiw_step3_bear_case: "Negatives Szenario",
    hiw_step3_key_risks: "Hauptrisiken",
    hiw_step3_key_drivers: "Wichtigste Treiber",
    hiw_step3_bull_case_example: "Starker Cashflow",
    hiw_step3_bear_case_example: "Schw\u00E4cheres Wachstum",
    hiw_step3_key_risks_example: "Wettbewerbsdruck",
    hiw_step3_key_drivers_example: "Margen & freier Cashflow",
    how_it_works_cta: "Aktie analysieren",
    // Landing 1 (2026-08-10) — subtile Einzeilen-Metadaten unter jeder
    // KI-Marktradar-Karte. Ersetzt die drei bisherigen Zeilen
    // (Datenstand / Analyse aktualisiert / Modell: <interne ID>). Der
    // Marktradar ist explizit eine "Beispielvorschau"; hier wird kein
    // Datum ausgewiesen, um keinen dauerhaft aktuellen Datenstand zu
    // suggerieren.
    pick_model_example_preview: "Modell: Beispielvorschau",
    pick_data_as_of: "Daten vom: {date}",
    pick_analysis_updated: "Analyse aktualisiert: {date}",
    pick_model: "Modell: {model}",
    pick_snapshot_published: "Snapshot veröffentlicht: {date}",
    // Landing 1 correction (2026-08-11) — minimaler, expliziter
    // Non-Chart-Status. Wird nie angezeigt, wenn legitime
    // gecachte Reihen existieren; visuell minimal und eindeutig
    // ein Text-Status, KEIN dekoratives Pseudo-Chart.
    pick_chart_unavailable: "Chart nicht verf\u00FCgbar",
    picks_eyebrow: "KI-ANALYSE \u00B7 BEISPIELE",
    picks_title: "KI-Marktradar",
    picks_subtitle: "Entdecke Beispielanalysen f\u00FCr unterbewertete, fair bewertete und \u00FCberbewertete Aktien.",
    picks_as_of: "Stand {time}",
    picks_refresh: "Aktualisieren",
    legend_balanced: "Ausgewogene \u00DCbersicht \u00B7 nicht alle gezeigten Aktien sind Kaufgelegenheiten.",
    legend_opportunity: "Gelegenheit",
    legend_opportunity_desc: "Unter dem fairen Wert",
    legend_neutral: "Neutral",
    legend_neutral_desc: "Fair bewertet",
    legend_risk: "Risiko",
    legend_risk_desc: "Preis voraus zur Substanz",
    picks_disclaimer: "Eine ausgewogene \u00DCbersicht \u2014 mindestens 2 Gelegenheiten, 1 fair bewertete und 1 Risikoaktie f\u00FCr ein realistisches Marktbild. Keine Kauf-/Verkaufsempfehlung.",
    trust_cashflow_title: "Cashflow",
    trust_cashflow_sub: "Stärke und Beständigkeit des Cashflows",
    trust_valuation_title: "Bewertung",
    trust_valuation_sub: "Fair Value auf Basis von Unternehmens- und Branchendaten",
    trust_profitability_title: "Profitabilität",
    trust_profitability_sub: "Rendite, Margen & Gewinnqualität",
    trust_ai_title: "KI-Einblick",
    trust_ai_sub: "Klare Einblicke auf Basis der Analyse",
    trust_footnote: "Jeder Score basiert auf echten Fundamentaldaten \u2014 keine Black-Box-Magie.",
    trust_footnote_line1: "Jeder Score basiert auf echten Fundamentaldaten",
    trust_footnote_line2: "\u2014 keine Black-Box-Magie.",
    cta_title: "Schluss mit Raten. Jetzt analysieren.",
    cta_subtitle: "Kostenlos f\u00FCr deine ersten 10 Analysen. Keine Kreditkarte n\u00F6tig.",
    cta_signup: "Kostenlosen Account erstellen",
    // Sub-pass 2A (2026-02-17)
    cta_signup_final: "Analysiere deine erste Aktie",
    // Sub-pass 2A (2026-02-17)
    snapshot_score_scale_disclosure: "Die finale Klassifizierung ber\u00FCcksichtigt zus\u00E4tzlich Bewertung, Aufw\u00E4rtspotenzial, Risiko und deterministische Guardrails.",
    snapshot_score_scale_aria: "AI Opportunity Score {score} von 100 \u2014 Score-Band: {band}.",
    snapshot_score_scale_band_risk: "Risk (unter 45)",
    snapshot_score_scale_band_neutral: "Neutral (45-59)",
    snapshot_score_scale_band_opportunity: "Opportunity-Schwelle (60-74)",
    snapshot_score_scale_band_top: "Top Opportunity-Schwelle (75-100)",
    cta_pricing: "Preise ansehen",
    // Landing Page Polish 3 — zweisprachige FAQ (8 Fragen).
    faq_eyebrow: "FAQ",
    faq_title: "Fragen, verst\u00E4ndlich beantwortet.",
    faq_subtitle: "Alles, was du vor deiner ersten Stockaily-Analyse wissen solltest.",
    faq_q1_q: "Kann ich Stockaily kostenlos testen?",
    faq_q1_a: "Ja. Du erh\u00E4ltst im ersten Monat zehn kostenlose Aktienanalysen \u2013 ohne Kreditkarte. Danach stehen Free-Mitgliedern dauerhaft f\u00FCnf kostenlose Aktienanalysen pro Monat zur Verf\u00FCgung.",
    faq_q2_q: "Welche Aktien kann ich analysieren?",
    faq_q2_a: "Stockaily unterst\u00FCtzt Tausende b\u00F6rsennotierte Aktien aus verschiedenen M\u00E4rkten. Die Abdeckung h\u00E4ngt davon ab, ob die erforderlichen Finanzdaten f\u00FCr eine verl\u00E4ssliche Analyse verf\u00FCgbar sind. Lassen sich wichtige Eingaben nicht validieren, zeigt Stockaily die Analyse oder Bewertung als nicht verf\u00FCgbar an, statt ein ungepr\u00FCftes Ergebnis auszugeben. ETFs und ETNs werden derzeit nicht unterst\u00FCtzt.",
    faq_q3_q: "Was bedeutet der AI Opportunity Score?",
    faq_q3_a: "Der AI Opportunity Score fasst Bewertung, Unternehmensqualit\u00E4t, Wachstum sowie Risiko- und Sicherheitsfaktoren auf einer Skala von 0 bis 100 zusammen. Er hilft dir, das analytische Gesamtbild einer Aktie einzuordnen, ist aber keine Kauf-, Verkaufs- oder Halteempfehlung.",
    faq_q4_q: "Wie ermittelt Stockaily den Fair Value?",
    faq_q4_a: "Stockaily kombiniert abh\u00E4ngig vom Unternehmen und den verf\u00FCgbaren Daten geeignete Bewertungsmethoden, darunter Discounted Cashflow und sektorrelative Ans\u00E4tze. Das Ergebnis ist eine gesch\u00E4tzte Fair-Value-Spanne und kein garantiertes Kursziel. Bewertungsannahmen und Marktbedingungen k\u00F6nnen sich ver\u00E4ndern.",
    faq_q5_q: "Wie aktuell und verl\u00E4sslich sind die Daten?",
    faq_q5_a: "Stockaily verwendet Markt- und Fundamentaldaten externer Anbieter und zeigt verf\u00FCgbare Daten- und Aktualisierungszeitpunkte an. Daten k\u00F6nnen verz\u00F6gert, unvollst\u00E4ndig, nachtr\u00E4glich ge\u00E4ndert oder vor\u00FCbergehend nicht verf\u00FCgbar sein. Stockaily nutzt Validierungs- und Abstimmungspr\u00FCfungen und zeigt keine Bewertung an, wenn wesentliche Eingaben nicht verifiziert werden k\u00F6nnen.",
    faq_q6_q: "Welche Rolle spielt KI bei der Analyse?",
    faq_q6_a: "Das Bewertungsmodell von Stockaily berechnet die zentralen Scores und Bewertungsergebnisse aus strukturierten Finanzdaten. KI-gest\u00FCtzte Texte erkl\u00E4ren diese Modellergebnisse und heben relevante Chancen und Risiken hervor, \u00FCberschreiben die berechnete Bewertung aber nicht eigenst\u00E4ndig.",
    faq_q7_q: "Ist Stockaily eine Anlageberatung?",
    faq_q7_a: "Nein. Stockaily bietet modellbasierte Finanzanalysen und Informationen f\u00FCr deine eigene Bewertung. Deine pers\u00F6nliche finanzielle Situation wird nicht ber\u00FCcksichtigt. Stockaily bietet keine pers\u00F6nliche Anlageberatung, Orderausf\u00FChrung, Empfehlung zur Positionsgr\u00F6\u00DFe oder garantierte Rendite. Investieren ist mit Risiken verbunden.",
    faq_q8_q: "Was ist in den kostenpflichtigen Tarifen enthalten und kann ich k\u00FCndigen?",
    faq_q8_a: "Pro und Premium bieten je nach gew\u00E4hltem Tarif h\u00F6here oder unbegrenzte Nutzungslimits sowie zus\u00E4tzliche Analyse-, Watchlist- und Portfoliofunktionen. Die aktuellen Leistungen und Preise findest du auf der Pricing-Seite. Kostenpflichtige Abonnements k\u00F6nnen jederzeit gek\u00FCndigt werden und bleiben vorbehaltlich der geltenden Bedingungen bis zum Ende des bezahlten Abrechnungszeitraums verf\u00FCgbar.",
    faq_q8_pricing_link_text: "Pricing-Seite",
    // Landing Page Polish 4 — Portfolio Showcase / Preview Loop.
    showcase_eyebrow: "PORTFOLIO INTELLIGENCE",
    showcase_heading: "Verstehe dein gesamtes Portfolio auf einen Blick.",
    showcase_subtitle: "Behalte Performance, Bewertung, Chancen und Risiken im Blick \u2013 und entwickle daraus einen klaren Research-Plan.",
    showcase_example_badge: "Beispielportfolio \u00B7 Beispieldaten",
    showcase_disclosure: "Beispielhafte Oberfl\u00E4che und Daten \u2013 keine tats\u00E4chliche Portfolio-Performance oder Anlageberatung.",
    showcase_play: "Showcase abspielen",
    showcase_pause: "Showcase pausieren",
    showcase_reduced_static: "Statische Vorschau \u2013 reduzierte Bewegung aktiviert.",
    showcase_header_title: "Portfolio Intelligence",
    showcase_header_subtitle: "Verfolge deine Positionen anhand von Stockailys Fair Value, Opportunity Score und Risikorahmen.",
    showcase_refresh_prices: "Kurse aktualisieren",
    showcase_analyze_portfolio: "Portfolio analysieren",
    showcase_analyze_running: "Analysiere\u2026",
    showcase_update_analysis: "Portfolioanalyse aktualisieren",
    showcase_add_holding: "Position hinzuf\u00FCgen",
    showcase_premium_ai: "PREMIUM AI",
    showcase_loading_msg: "Der Buffett-Check wird auf dein Portfolio angewendet\u2026",
    showcase_kpi_value: "Portfoliowert",
    showcase_kpi_value_hint: "Anschaffungswert: 25.000\u00A0$",
    showcase_kpi_fv: "Gesch\u00E4tzter Fair Value",
    showcase_kpi_upside: "Auf-/Abw\u00E4rtspotenzial",
    showcase_kpi_upside_hint: "Sch\u00E4tzung vs. aktueller Portfoliowert",
    showcase_kpi_pnl: "Nicht realisiertes P/L",
    showcase_kpi_score: "Gewichteter Opportunity Score",
    showcase_kpi_score_hint: "Wertgewichtet \u00FCber alle Positionen",
    showcase_kpi_risk: "Risikoniveau",
    showcase_risk_medium: "Mittel",
    showcase_growth_title: "Portfolio-Wachstum",
    showcase_growth_sub: "Wert vs. gesch\u00E4tzter Fair Value",
    showcase_time_weighted: "Zeitgewichtete Rendite",
    showcase_good: "GUT",
    showcase_portfolio_return: "PORTFOLIO-RENDITE",
    showcase_sp500_return: "S&P 500-RENDITE",
    showcase_relative_perf: "RELATIVE PERFORMANCE",
    showcase_axis_perf: "Performance-Index",
    showcase_axis_fv: "Gesch\u00E4tzter Fair Value ($)",
    showcase_legend_fv: "Gesch\u00E4tzter Fair Value",
    showcase_legend_portfolio: "Portfoliowert",
    showcase_legend_sp500: "S&P 500 Benchmark (Index)",
    showcase_tooltip_date: "DATUM:",
    showcase_tooltip_portfolio_index: "Portfolio-Index",
    showcase_tooltip_portfolio_value: "Portfoliowert",
    showcase_tooltip_sp500_index: "S&P 500 Index",
    showcase_tooltip_est_fv: "Gesch. Fair Value",
    showcase_tooltip_portfolio_since: "Portfolio seit 1J-Beginn",
    showcase_tooltip_sp500_since: "S&P 500 seit 1J-Beginn",
    showcase_tooltip_relative: "Relative Performance",
    showcase_top_opportunity: "TOP-CHANCE",
    showcase_top_opportunity_desc: "Position mit dem gr\u00F6\u00DFten Aufw\u00E4rtspotenzial gegen\u00FCber dem gesch\u00E4tzten Fair Value.",
    showcase_largest_risk: "GR\u00D6SSTES BEWERTUNGSRISIKO",
    showcase_largest_risk_desc: "Position, die am weitesten \u00FCber dem gesch\u00E4tzten Fair Value gehandelt wird.",
    showcase_highest_weight: "GR\u00D6SSTES GEWICHT",
    showcase_highest_weight_desc: "Position mit dem gr\u00F6\u00DFten Anteil am Portfolio.",
    showcase_biggest_winner: "GR\u00D6SSTER GEWINNER",
    showcase_biggest_winner_desc: "St\u00E4rkste nicht realisierte Rendite.",
    showcase_biggest_loser: "GR\u00D6SSTER VERLIERER",
    showcase_biggest_loser_desc: "Gr\u00F6\u00DFter nicht realisierter Verlust.",
    showcase_concentration: "KONZENTRATION",
    showcase_concentration_desc: "Anteil des Sektors Finanzwerte am Portfolio.",
    showcase_col_ticker: "Ticker",
    showcase_col_company: "Unternehmen",
    showcase_col_shares: "St\u00FCck",
    showcase_col_buy: "Kaufkurs",
    showcase_col_current: "Aktuell",
    showcase_col_mv: "Marktwert",
    showcase_col_pnl: "P/L",
    showcase_col_weight: "Gewicht",
    showcase_col_fv: "Fair Value",
    showcase_col_upside: "Potenzial",
    showcase_col_score: "AI Score",
    showcase_col_risk: "Risiko",
    showcase_risk_low: "Niedrig",
    showcase_risk_med: "Mittel",
    showcase_risk_high: "Hoch",
    showcase_signal_top_opportunity: "Top-Chance",
    showcase_signal_opportunity: "Chance",
    showcase_signal_fair: "Fair",
    showcase_signal_valuation_risk: "Bewertungsrisiko",
    showcase_review_title: "KI-Portfolio-Analyse",
    showcase_review_badge: "Portfolio Intelligence \u00B7 KI-gest\u00FCtzt",
    showcase_review_badge_example: "Beispiel",
    showcase_review_up_to_date: "Aktuell",
    showcase_review_summary:
      "Das Portfolio verbindet eine positive Performance mit mehreren Positionen, die unter ihrem gesch\u00E4tzten Fair Value notieren. Die Chancen verteilen sich auf mehrere Sektoren, w\u00E4hrend Bewertung und Sektorkonzentration weiterhin beobachtet werden sollten.",
    showcase_review_strengths: "ST\u00C4RKEN",
    showcase_review_weaknesses: "SCHW\u00C4CHEN",
    showcase_review_concentration: "KONZENTRATIONSRISIKEN",
    showcase_review_priorities: "RESEARCH-PRIORIT\u00C4TEN",
    showcase_review_confidence:
      "Vertrauen: Beispielhafte Darstellung auf Basis der gezeigten Positionen und Fundamentaldaten; keine pers\u00F6nliche Empfehlung.",
    showcase_review_strengths_1: "Mehrere Positionen notieren unter ihrem gesch\u00E4tzten Fair Value.",
    showcase_review_strengths_2: "Das Portfolio zeigt insgesamt eine positive Performance.",
    showcase_review_strengths_3: "Die Anlagen verteilen sich auf f\u00FCnf Sektoren.",
    showcase_review_weaknesses_1: "Apple notiert \u00FCber seinem beispielhaften gesch\u00E4tzten Fair Value.",
    showcase_review_weaknesses_2: "Nicht jede Position bietet aktuell das gleiche Chancenpotenzial.",
    showcase_review_concentration_1: "Finanzwerte machen 34\u00A0% des Portfolios aus und sollten weiter beobachtet werden.",
    showcase_review_priorities_1: "Die Cashflow-Entwicklung von PayPal pr\u00FCfen.",
    showcase_review_priorities_2: "Den Kapitalbedarf von NextEra Energy beobachten.",
    showcase_review_priorities_3: "Die Bewertungsannahmen f\u00FCr Apple neu bewerten.",
    showcase_pl_breakdown_title: "GEWINN- / VERLUSTAUFTEILUNG",
    showcase_pl_unrealized: "Nicht realisierter G/V",
    showcase_pl_realized: "Realisierter G/V",
    showcase_pl_total: "Gesamt-G/V",
  },
  pricing: {
    pill: "Einfache, transparente Preise",
    title_main: "Finde deinen Edge.",
    title_sub: "Investiere mit mehr \u00DCberzeugung.",
    subtitle: "Starte mit den Kernbewertungen. Erhalte mit Pro die vollst\u00E4ndige Aktien-Recherche. Verstehe dein gesamtes Portfolio mit Premium.",
    monthly: "Monatlich",
    yearly: "J\u00E4hrlich",
    most_popular: "Am beliebtesten",
    premium_tier: "Premium-Stufe",
    no_card: "Keine Kreditkarte n\u00F6tig.",
    switch_to_yearly: "Wechsle auf j\u00E4hrlich und spare \u20AC{amount} pro Jahr",
    compare_features: "Funktionen vergleichen",
    trust_cancel_title: "Jederzeit k\u00FCndbar",
    trust_cancel_body: "Keine langfristige Bindung. Jederzeit zur\u00FCck zu Free wechseln.",
    trust_eu_title: "EU-Abrechnung & MwSt.",
    trust_eu_body: "Rechnungen enthalten gegebenenfalls MwSt. und werden automatisch per E-Mail zugesandt.",
    trust_nospam_title: "Kein Spam, keine Popups",
    trust_nospam_body: "Wir verkaufen deine Daten nicht und unterbrechen deinen Workflow nicht mit Sales-Overlays.",
    plans: {
      free_tagline: "Erlebe Stockaily mit den vollst\u00E4ndigen Kernbewertungen.",
      pro_tagline: "Vollst\u00E4ndige Aktien-Recherche f\u00FCr aktive Anleger.",
      premium_tagline: "Portfolio-Intelligenz f\u00FCr jede Position.",
      free_cta: "Jetzt starten",
      pro_cta: "Auf Pro upgraden",
      premium_cta: "Auf Premium upgraden",
    },
    feature_groups: {
      "Core": "Kernfunktionen",
      "Complete stock research": "Vollst\u00E4ndige Aktien-Recherche",
      "Everything in Pro, plus": "Alles aus Pro, plus",
      "Coming next": "Kommt als N\u00E4chstes",
      // Legacy keys
      "Limitations": "Einschr\u00E4nkungen",
      "Everything you need": "Alles, was du brauchst",
      "Coming soon": "Demn\u00E4chst",
    },
    features: {
      // Free
      "10 analyses in your first 30 days": "10 Analysen in deinen ersten 30 Tagen",
      "5 analyses every rolling 30 days after that": "Danach 5 Analysen pro rollierende 30 Tage",
      "AI Opportunity Score": "AI Opportunity Score",
      "Fair Value & upside/downside": "Fair Value & Up-/Downside",
      "Risk level": "Risiko-Level",
      "Basic AI summary": "Einfache KI-Zusammenfassung",
      "Up to 10 watchlist stocks": "Bis zu 10 Watchlist-Aktien",
      // Pro
      "Unlimited stock analyses": "Unbegrenzte Aktienanalysen",
      "Full AI Insights": "Vollst\u00E4ndige AI Insights",
      "Bull & Bear Case": "Bull & Bear Case",
      "Detailed risk analysis": "Detaillierte Risikoanalyse",
      "Why This Score": "Why This Score",
      "Sector comparison": "Sektorvergleich",
      "Unlimited watchlist": "Unbegrenzte Watchlist",
      "Notes, labels & categories": "Notizen, Labels & Kategorien",
      "KPI explanations & tooltips": "KPI-Erkl\u00E4rungen & Tooltips",
      "Email alerts for price and fair-value changes": "E-Mail-Alerts f\u00FCr Preis- und Fair-Value-\u00C4nderungen",
      // Premium
      "Portfolio tracking": "Portfolio-Tracking",
      "Buy-price & position performance": "Einstandspreis & Positions-Performance",
      "Realized and unrealized P/L": "Realisierte und unrealisierte GuV",
      "Closed positions": "Geschlossene Positionen",
      "Portfolio Growth dashboard": "Portfolio-Growth-Dashboard",
      "Portfolio Fair Value": "Portfolio Fair Value",
      "Weighted Opportunity Score & risk": "Gewichteter Opportunity Score & Risiko",
      "Portfolio AI Review": "Portfolio AI Review",
      "S&P 500 benchmark": "S&P 500 Benchmark",
      "Portfolio refresh": "Portfolio-Aktualisierung",
      "Premium PDF reports": "Premium PDF-Berichte",
      "CSV export": "CSV-Export",
      // Phase 8.PH.FINAL — legacy labels kept for backward compat only.
      "CSV / XLSX exports": "CSV-Export",
      "Advanced portfolio analytics": "Erweiterte Portfolio-Analytik",
      // Legacy keys retained for cached backend payloads
      "10 analyses in first 30 days": "10 Analysen in deinen ersten 30 Tagen",
      "5 analyses per rolling 30 days": "Danach 5 Analysen pro rollierende 30 Tage",
      "Basic valuation access": "Fair Value & Up-/Downside",
      "Up to 10 watchlist tickers": "Bis zu 10 Watchlist-Aktien",
      "No portfolio tracking": "Kein Portfolio-Tracking",
      "Limited AI reasoning": "Begrenzte KI-Begr\u00FCndungen",
      "Unlimited analyses": "Unbegrenzte Aktienanalysen",
      "Full AI insights": "Vollst\u00E4ndige AI Insights",
      "Unlimited watchlist items": "Unbegrenzte Watchlist",
      "Watchlist notes": "Notizen, Labels & Kategorien",
      "Watchlist labels & categories": "Notizen, Labels & Kategorien",
      "AI risk analysis": "Detaillierte Risikoanalyse",
      "Bull / Bear case analysis": "Bull & Bear Case",
      "Email alerts on price & fair-value crossings": "E-Mail-Alerts f\u00FCr Preis- und Fair-Value-\u00C4nderungen",
      "Portfolio growth dashboard": "Portfolio-Growth-Dashboard",
      "Buy-price tracking & position performance": "Einstandspreis & Positions-Performance",
      "Portfolio AI analysis": "Portfolio AI Review",
      "Portfolio fair value & opportunity scoring": "Portfolio Fair Value",
      "S&P 500 benchmark (coming soon)": "S&P 500 Benchmark",
      "PDF reports (coming soon)": "Premium PDF-Berichte",
      "CSV / XLSX export (coming soon)": "CSV / XLSX-Exporte",
      "Advanced stock screener": "Erweiterte Portfolio-Analytik",
      "Data export (CSV / XLSX)": "CSV / XLSX-Exporte",
      "Future advanced analytics modules": "Erweiterte Portfolio-Analytik",
    },
    compare: {
      group_analyses: "Analysen & KI",
      group_watchlist: "Watchlist",
      group_portfolio: "Portfolio-Intelligenz",
      row_analyses: "Analysen",
      row_ai_score: "AI Opportunity Score",
      row_fair_value: "Fair Value & Up-/Downside",
      row_ai: "KI-Einblicke",
      row_ai_risk: "Detaillierte Risikoanalyse",
      row_bull_bear: "Bull & Bear Case",
      row_why_score: "Why This Score",
      row_sector: "Sektorvergleich",
      row_kpi: "KPI-Erkl\u00E4rungen & Tooltips",
      row_wl_count: "Watchlist-Aktien",
      row_notes: "Notizen",
      row_labels: "Labels & Kategorien",
      row_alerts: "E-Mail-Alerts",
      row_portfolio: "Portfolio-Tracking",
      row_buy_price: "Einstandspreis-Tracking",
      row_position_performance: "Positions-Performance",
      row_unrealized_pl: "Unrealisierte GuV",
      row_realized_pl: "Realisierte GuV",
      row_closed_positions: "Geschlossene Positionen",
      row_portfolio_fair_value: "Portfolio Fair Value",
      row_weighted_opp: "Gewichteter Opportunity Score",
      row_portfolio_risk: "Portfolio-Risiko\u00FCbersicht",
      row_portfolio_ai_review: "Portfolio AI Review",
      row_dashboard: "Portfolio-Growth-Dashboard",
      row_sp500: "S&P 500 Benchmark",
      row_portfolio_refresh: "Portfolio-Aktualisierung",
      row_pdf_export: "Premium PDF-Berichte",
      row_export: "CSV-Export",
      row_advanced_analytics: "Erweiterte Portfolio-Analytik",
      // Legacy row keys
      row_position: "Einstandspreis & Positions-Performance",
      row_ai_portfolio: "Portfolio AI Review",
      row_screener: "Erweiterte Portfolio-Analytik",
      // Value labels
      val_free_analyses: "10 erste 30T \u00B7 dann 5 / 30T",
      val_ai_basic: "Einfache Zusammenfassung",
      val_ai_full: "Vollst\u00E4ndige AI Insights",
      val_risk_basic: "Einfaches Risiko-Level",
      val_limited: "Begrenzt",
      val_up_to_10: "Bis zu 10",
      val_unlimited: "Unbegrenzt",
      val_coming_soon: "Demn\u00E4chst",
      // Legacy value keys
      val_basic_preview: "Einfache Zusammenfassung",
      val_full_reasoning: "Vollst\u00E4ndige AI Insights",
    },
  },
  watchlist: {
    title: "Watchlist",
    subtitle: "Speichere Aktien hier, um Preis, fairen Wert und KI-Score auf einen Blick zu verfolgen.",
    add_placeholder: "Ticker hinzuf\u00FCgen",
    free_quota: "Watchlist (Free-Plan)",
    at_limit: "Du hast das Limit des Free-Plans erreicht. Upgrade auf Pro f\u00FCr unbegrenzte Watchlists und KI-Tracking.",
    add_more: "F\u00FCge {n} weitere Aktie im Free-Plan hinzu \u2014 oder wechsle auf Pro f\u00FCr unbegrenzt.",
    add_more_plural: "F\u00FCge {n} weitere Aktien im Free-Plan hinzu \u2014 oder wechsle auf Pro f\u00FCr unbegrenzt.",
    unlimited_chip: "Unbegrenzte Watchlist auf deinem {plan}-Plan",
    empty_title: "Noch nichts gespeichert",
    empty_subtitle: "F\u00FCge deine erste Aktie hinzu, um Preis, Fair Value und KI-Opportunity-Score zu verfolgen.",
    empty_cta: "F\u00FCge deine erste Aktie hinzu",
    empty_secondary: "Stattdessen eine Aktie analysieren",
    failed_load: "Watchlist konnte nicht geladen werden",
    failed_remove: "Entfernen fehlgeschlagen",
    removed: "{ticker} entfernt",
    saved: "Notizen f\u00FCr {ticker} gespeichert",
    failed_save: "Speichern fehlgeschlagen",
    col_ticker: "Ticker",
    col_name: "Name",
    col_notes: "Notizen & Tags",
    col_price: "Preis",
    col_price_as_of_analysis: "Stand Analyse {time}",
    col_price_tooltip: "Preis stammt aus der gespeicherten Analyse ({time}) und ist keine Live-Kursabfrage.",
    stale_badge: "Veraltet",
    stale_label: "Letzte Analyse {time} · veraltet",
    stale_label_fresh: "Letzte Analyse {time}",
    stale_tooltip: "Diese Analyse ist \u00E4lter als 24 Stunden. Bitte neu analysieren, um Preis, Fairen Wert und Upside gemeinsam zu aktualisieren.",
    col_fair: "Fairer Wert",
    col_upside: "Upside",
    col_score: "Score",
    col_status: "Status",
    status_not_analyzed_yet: "Noch nicht analysiert",
    col_updated: "Aktualisiert",
    col_actions: "Aktionen",
    edit_title_pro: "Notizen, Labels & Sektor bearbeiten",
    edit_title_locked: "Verf\u00FCgbar in Pro",
    btn_analyze: "Analysieren",
    no_notes: "Noch keine Notizen",
    pro_feature: "Pro-Funktion",
    notes_label: "Notizen",
    notes_placeholder: "Warum beobachtest du {ticker}? Earnings-Setup, Ziel-Einstieg, Exit-These\u2026",
    labels_label: "Labels",
    labels_add_placeholder: "Eigenes Label hinzuf\u00FCgen\u2026",
    sector_label: "Sektor & Themen",
    pro_toast_title: "Notizen & Labels gibt's in Pro",
    pro_toast_desc: "Tagge Aktien nach These, hinterlasse Notizen pro Analyse, gruppiere nach Sektor. Verf\u00FCgbar in Pro und Premium.",
    pro_toast_action: "Upgrade",
    teaser_title: "Notizen, Labels & Sektor-Tags gibt's in Pro",
    teaser_body: "Tagge Aktien nach These (KI \uD83E\uDD16, Semis \uD83D\uDCBE, Space \uD83D\uDE80\u2026) und hinterlasse Notizen nach jeder Analyse.",
    add_success: "{ticker} zu deiner Watchlist hinzugef\u00FCgt.",
    add_success_analyze: "Jetzt analysieren",
    add_already: "Bereits in deiner Watchlist.",
    add_error: "Konnte nicht zur Watchlist hinzugef\u00FCgt werden.",
    add_invalid: "Dieses Ticker-Symbol konnte nicht hinzugef\u00FCgt werden.",
    limit_toast: "Watchlist-Limit erreicht.",
    add_placeholder_desktop: "Aktie per Ticker oder Firma hinzuf\u00FCgen",
    add_a11y_label: "Aktie per Ticker oder Firmennamen hinzuf\u00FCgen",
    loggedout_title: "Baue deine Stockaily-Watchlist",
    loggedout_subtitle: "Verfolge Preis, fairen Wert und KI-Score an einem Ort.",
    loggedout_signup: "Kostenlos registrieren",
    loggedout_login: "Anmelden",
    analysis_section_kicker: "TIEFERGEHENDE ANALYSE",
    analysis_section_title: "Aktie analysieren",
    analysis_section_body: "Erhalte Fair Value, Opportunity-Score, Risiko und KI-Insights in Sekunden.",
    analysis_capabilities: "Fair Value \u00B7 Opportunity Score \u00B7 Risiko \u00B7 KI-Insights",
    analysis_placeholder: "Aktie zum Analysieren suchen",
    analysis_placeholder_mobile: "Aktie analysieren",
    sort: {
      button: "Sortieren",
      header: "Sortieren nach",
      asc: "Aufst.",
      desc: "Abst.",
      recently_added: "K\u00FCrzlich hinzugef\u00FCgt",
      ticker: "Ticker",
      name: "Name",
      price: "Preis",
      fair_value: "Fairer Wert",
      upside: "Upside",
      ai_score: "KI-Score",
      status: "Status",
      last_updated: "Zuletzt aktualisiert",
      reset_default: "Auf Standard zur\u00FCcksetzen",
    },
    filter: {
      button: "Filter",
      sheet_desc: "Filtere deine Watchlist nach Bewertung, Labels oder Sektoren.",
      valuation_status: "Bewertungsstatus",
      status_undervalued: "Unterbewertet",
      status_fair: "Fair bewertet",
      status_overvalued: "\u00DCberbewertet",
      labels: "Labels",
      sectors: "Sektor & Themen",
      reset: "Filter zur\u00FCcksetzen",
      active_count: "Aktive Filter:",
      hint_no_meta: "F\u00FCge Labels oder Sektor-Tags im Editor hinzu, um mehr Filter zu aktivieren.",
      empty_title: "Keine Aktien entsprechen deinen Filtern",
      empty_subtitle: "{hidden} Aktie(n) durch Filter ausgeblendet.",
    },
    freshness: {
      latest_data: "Letzte Daten",
      latest_available_data: "Zuletzt verf\u00FCgbare Daten",
      updated_ago: "{age}",
      unavailable: "Aktualisierungszeit nicht verf\u00FCgbar",
      unavailable_short: "\u2014",
    },
    sector: {
      show_more: "Mehr anzeigen",
      more_header: "Weitere Sektoren & Themen",
      mobile_desc: "W\u00E4hle bis zu 3 Tags.",
      count_of_max: "{n} / {max} ausgew\u00E4hlt",
      max_reached: "Max. 3 Sektoren",
      max_reached_hint: "Max. 3 \u2014 einen abw\u00E4hlen, um weitere hinzuzuf\u00FCgen",
    },
    suggested_labels: {
      "Long-term": "Langfristig",
      "Earnings Watch": "Earnings-Watch",
      "Risk Flag": "Risiko-Flag",
      "High Conviction": "Hohe \u00DCberzeugung",
      "Dividend Candidate": "Dividenden-Kandidat",
      "Research": "Recherche",
      "Watching": "Beobachten",
      "Earnings play": "Earnings-Spiel",
      "Dividend": "Dividende",
      "Speculative": "Spekulativ",
      "Add on dip": "Bei R\u00FCcksetzer aufstocken",
      "Trim on rally": "Bei Rallye reduzieren",
      "Thesis intact": "These intakt",
      "Risk flag": "Risiko-Flag",
    },
    sectors: {
      ai: "KI",
      semis: "Halbleiter",
      software: "Software",
      cloud: "Cloud",
      cybersec: "Cybersicherheit",
      banks: "Banken",
      fintech: "Fintech",
      insurance: "Versicherung",
      finance: "Finanzen",
      healthcare: "Gesundheit",
      biotech: "Biotech",
      pharma: "Pharma",
      energy: "Energie",
      clean_energy: "Saubere Energie",
      industrial: "Industrie",
      aerospace: "Luftfahrt",
      auto: "Auto / EV",
      consumer: "Konsum",
      media: "Medien",
      telecom: "Telekom",
      reits: "REITs",
      materials: "Materialien",
      utilities: "Versorger",
      space: "Raumfahrt",
      crypto: "Krypto",
    },
  },
  auth: {
    welcome_back: "Willkommen zur\u00FCck.",
    welcome_back_sub: "Melde dich an, um deine Watchlist zu \u00F6ffnen und KI-Bewertungen f\u00FCr deine Aktien fortzusetzen.",
    login_title: "Anmelden",
    login_subtitle: "Mit E-Mail oder Google anmelden.",
    google: "Mit Google fortfahren",
    google_failed: "Die Google-Anmeldung ist fehlgeschlagen. Bitte versuche es erneut.",
    email_label: "E-Mail",
    email_placeholder: "du@stockaily.ai",
    password_label: "Passwort",
    password_placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
    name_label: "Name",
    name_placeholder: "Dein Name",
    signing_in: "Wird angemeldet\u2026",
    log_in: "Anmelden",
    no_account: "Noch kein Konto?",
    create_one: "Konto erstellen",
    forgot_password_link: "Passwort vergessen?",
    welcome_toast: "Willkommen zur\u00FCck bei Stockaily.",
    bad_creds: "Ung\u00FCltige E-Mail oder Passwort",
    signup_kicker: "Finde unterbewertete Aktien in Sekunden.",
    signup_kicker_sub: "Free-Plan startet mit 10 Analysen, danach 5 pro rollierende 30 Tage. Jederzeit upgradebar.",
    signup_title: "Konto erstellen",
    signup_subtitle: "Kostenlos starten. Keine Kreditkarte n\u00F6tig.",
    signup_password_placeholder: "Mindestens 6 Zeichen",
    creating: "Wird erstellt\u2026",
    create_account: "Konto erstellen",
    have_account: "Bereits ein Konto?",
    welcome_signup_toast: "Willkommen bei Stockaily.",
    signup_failed: "Registrierung fehlgeschlagen",
    password_too_short: "Passwort muss mindestens 6 Zeichen lang sein",
  },
  billing: {
    title: "Abrechnung & Nutzung",
    subtitle: "Verwalte deinen Plan und behalte verbleibende Analysen im Blick.",
    plan_label: "Plan",
    billed_label: "Abrechnung",
    analyses_used: "Verwendete Analysen",
    unlimited_msg: "Unbegrenzt \u2014 genie\u00DFe deinen {plan}-Plan.",
    used_in_first: "{used} / {limit} in den ersten 30 Tagen",
    used_in_rolling: "{used} / {limit} in den letzten {days} Tagen",
    remaining: "{remaining} Analysen verbleibend",
    choose_plan: "W\u00E4hle deinen Plan",
    recommended: "Empfohlen",
    redirect_msg: "Weiterleitung zur Kasse (CopeCart-Platzhalter)\u2026",
    switch_free: "Auf Free wechseln",
    checkout_yearly: "J\u00E4hrlich kaufen",
    checkout_monthly: "Monatlich kaufen",
    activate_test: "Aktivieren (Test)",
    plan_switched: "Plan zu {plan} gewechselt",
    failed_update: "Plan konnte nicht aktualisiert werden",
    checkout_failed: "Checkout fehlgeschlagen",
    disclaimer: "CopeCart Checkout ist eingerichtet, aber noch nicht \u00F6ffentlich aktiviert.",
    disclaimer_enabled: "Die sichere Zahlung wird \u00FCber CopeCart verarbeitet.",
    disclaimer_disabled: "CopeCart Checkout ist eingerichtet, aber noch nicht \u00F6ffentlich aktiviert.",
    // Phase 7.UI.15k — Fortsetzungsseite nach Anmeldung.
    continue: {
      preparing_title: "Wir bereiten deinen sicheren Checkout vor\u2026",
      preparing_body: "Wir leiten dich gleich mit deinem gew\u00E4hlten Plan zu CopeCart weiter. Es dauert nur einen Moment.",
      ready_title: "Dein Checkout ist bereit",
      ready_body: "Falls dein Browser CopeCart nicht automatisch ge\u00F6ffnet hat, nutze den Button unten.",
      cta: "Zum sicheren Checkout fortfahren",
      cancel: "Abbrechen und zur Abrechnung zur\u00FCck",
      error_title: "Checkout konnte nicht vorbereitet werden",
      error_disabled: "Der Checkout ist noch nicht \u00F6ffentlich verf\u00FCgbar. Bitte sp\u00E4ter erneut versuchen oder den Support kontaktieren.",
      error_generic: "Beim Vorbereiten des Checkouts ist etwas schiefgelaufen. Du kannst den Plan auf der Abrechnungsseite erneut w\u00E4hlen.",
      retry: "Erneut versuchen",
      back_to_billing: "Zur Abrechnung",
    },
    success_charged_by_copecart: "Die Abbuchung erfolgt durch CopeCart.",
    // Phase 7.UI.15i — CopeCart-Abonnementverwaltung
    copecart: {
      title: "Dein CopeCart-Abo verwalten",
      subtitle: "Dein Abo wird von CopeCart abgewickelt und abgerechnet. K\u00FCndigung, Erstattungen und Rechnungen werden direkt \u00FCber CopeCart verwaltet.",
      current_plan: "Aktueller Plan",
      billing_interval: "Abrechnungsintervall",
      subscription_status: "Abostatus",
      access_until: "Zugriff g\u00FCltig bis",
      next_renewal: "N\u00E4chste Verl\u00E4ngerung",
      payment_provider: "Zahlungsanbieter",
      order_id: "Bestellnummer",
      transaction_id: "Transaktions-ID",
      subscription_id: "Abo-ID",
      purchase_email: "Kauf-E-Mail",
      cancel_button: "Abonnement bei CopeCart verwalten oder k\u00FCndigen",
      cancel_helper: "CopeCart verwaltet Abonnement, K\u00FCndigung, Widerruf und Rechnungen. Verwende daf\u00FCr die oben angezeigte Kauf-E-Mail und Bestell-ID.",
      cancel_safety: "Nutze nicht \u201EAuf Free wechseln\u201C zur K\u00FCndigung eines CopeCart-Abos. Dein Abo wird von CopeCart verwaltet. Stockaily passt deinen Plan automatisch an, sobald CopeCart die K\u00FCndigung oder den Ablauf best\u00E4tigt.",
      cancelled_notice: "K\u00FCndigung eingeplant. Dein Zugriff bleibt bis {date} aktiv.",
      past_due_notice: "Zahlung \u00FCberf\u00E4llig. Aktualisiere deine Zahlungsmethode bei CopeCart, um den Zugriff zu behalten.",
      invoices_title: "Abrechnung & Rechnungen",
      invoices_note: "Deine Rechnungen und Zahlungsbest\u00E4tigungen werden direkt von CopeCart an deine Kauf-E-Mail gesendet.",
      latest_payment: "Letzte Zahlung",
      test_badge: "Testzahlung",
      test_notice: "Dies ist ein CopeCart-Sandbox-/Testkauf. Er ist von den Abrechnungsmetriken ausgeschlossen, du kannst aber den K\u00FCndigungs-Flow testen.",
      copy_label: "Kopieren",
      copied_label: "Kopiert",
      switch_free_disabled_title: "\u201EAuf Free wechseln\u201C deaktiviert",
      switch_free_disabled_body: "Du hast ein aktives CopeCart-Abo. Nutze oben \u201EAbo bei CopeCart k\u00FCndigen\u201C, um die Abbuchungen zu stoppen. Stockaily aktualisiert deinen Plan automatisch, sobald CopeCart best\u00E4tigt.",
    },
    how_it_works: {
      title: "So funktioniert dein Abo",
      current_plan_row: "Aktueller Tarif",
      billing_interval_row: "Abrechnungszeitraum",
      allowance_row: "Analysen-Kontingent",
      billed_by_row: "Abgerechnet \u00FCber",
      cancellation_row: "So k\u00FCndigst du",
      access_until_row: "Zugang aktiv bis",
      allowance_unlimited: "Unbegrenzt",
      allowance_count: "{used} von {limit} verbraucht ({remaining} \u00FCbrig)",
      allowance_free_first_30d: "{used} von {limit} in den ersten 30 Tagen",
      billed_by_copecart: "CopeCart",
      billed_by_manual: "Manuell freigeschaltet \u2014 keine Abrechnung",
      billed_by_admin: "Admin-Freischaltung \u2014 keine Abrechnung",
      billed_by_promo: "Promo-Zugang \u2014 keine Abrechnung",
      billed_by_none: "Kein aktives kostenpflichtiges Abo",
      cancellation_copecart: "Verwalte oder k\u00FCndige bei CopeCart. Bezahlter Zugang bleibt bis zum K\u00FCndigungs- bzw. Laufzeitende aktiv.",
      cancellation_manual: "Wende dich an {email}, um deinen Tarif zu \u00E4ndern oder zu k\u00FCndigen.",
      cancellation_free: "Du bist im Free-Tarif. Es gibt nichts zu k\u00FCndigen.",
      billing_interval_none: "\u2014",
    },
    manage: {
      cta_copecart: "Bei CopeCart verwalten oder k\u00FCndigen",
      cta_support: "Support kontaktieren",
      loading: "Abo wird gepr\u00FCft\u2026",
      error_not_configured_title: "K\u00FCndigungslink nicht verf\u00FCgbar",
      error_not_configured_body: "Der CopeCart-Verwaltungslink ist noch nicht konfiguriert. Bitte kontaktiere {email}, um dein Abo zu k\u00FCndigen \u2014 wir k\u00FCmmern uns manuell und best\u00E4tigen per E-Mail.",
      error_generic_title: "K\u00FCndigung konnte nicht ge\u00F6ffnet werden",
      error_generic_body: "Beim Aufl\u00F6sen des K\u00FCndigungslinks ist etwas schiefgelaufen. Bitte versuche es gleich noch einmal oder kontaktiere {email}.",
      confirm_dialog_title: "Die K\u00FCndigung erfolgt bei CopeCart",
      confirm_dialog_body: "Stockaily k\u00FCndigt dein Abo nicht selbst. Wir \u00F6ffnen CopeCart in einem neuen Tab, damit du dort k\u00FCndigen kannst. Dein Stockaily-Zugang bleibt bis zum K\u00FCndigungs- bzw. Laufzeitende aktiv und wird automatisch angepasst, sobald CopeCart best\u00E4tigt.",
      confirm_dialog_confirm: "Weiter zu CopeCart",
      confirm_dialog_cancel: "Abo behalten",
      support_dialog_title: "Support kontaktieren, um Tarif zu \u00E4ndern",
      support_dialog_body: "Dein Tarif wurde au\u00DFerhalb von CopeCart freigeschaltet \u2014 dort gibt es also nichts zu k\u00FCndigen. Bitte kontaktiere {email}, um ihn zu \u00E4ndern oder zu k\u00FCndigen. Manuell freigeschaltete Tarife werden nicht automatisch heruntergestuft.",
      support_dialog_confirm: "E-Mail an Support",
      support_dialog_cancel: "Schlie\u00DFen",
      already_free_toast: "Du bist bereits im Free-Tarif.",
    },
  },
  paywall: {
    title: "Stockaily Pro freischalten",
    default_reason: "Du hast deine kostenlosen Analysen f\u00FCr diesen Zeitraum verbraucht. Upgrade f\u00FCr unbegrenzte Analysen, volle KI-Einblicke und Watchlist-Alerts.",
    bullet_unlimited: "Unbegrenzte Aktienanalysen",
    bullet_ai: "Volle KI-Einblicke & Zusammenfassung",
    bullet_alerts: "Watchlist & gespeicherte Analysen",
    later: "Sp\u00E4ter",
    see_plans: "Pl\u00E4ne ansehen",
  },
  not_found: {
    title: "404",
    body: "Seite nicht gefunden.",
    back: "Zur\u00FCck zur Startseite",
  },
  legal: {
    kicker: "Rechtliches",
    last_updated: "Zuletzt aktualisiert \u00B7 {date}",
    placeholder_note: "Diese Seite ist ein Platzhalter f\u00FCr das MVP. Der finale, l\u00E4nderspezifische Text wird vor dem \u00F6ffentlichen Launch gepr\u00FCft und ersetzt.",
    privacy: {
      title: "Datenschutzerkl\u00E4rung",
      last_updated: "Mai 2026",
      intro: "Stockaily (betrieben vom Stockaily-Team) sch\u00FCtzt deine Privatsph\u00E4re. Diese Richtlinie erkl\u00E4rt, welche Daten wir erfassen, warum wir sie erfassen und wie du deine Rechte aus\u00FCben kannst.",
      s1_h: "Was wir erfassen",
      s1_b1: "Kontodaten: deine E-Mail, dein Name, dein gehashtes Passwort und (bei Google-Login) deine Google-Konto-Kennung.",
      s1_b2: "Nutzungsdaten: welche Ticker du analysierst, deine Watchlist und aggregierte Z\u00E4hler, die deine Quote sowie die Social-Proof-Leiste auf der Startseite speisen.",
      s1_b3: "Abrechnungsdaten: Wenn du Pro oder Premium abonnierst, wickelt unser Zahlungsanbieter (CopeCart) die Zahlung ab. Wir speichern nur den resultierenden Plan- und Abostatus.",
      s1_b4: "Broker-Umfrage: Wir fragen angemeldete Mitglieder einmalig, welchen Broker oder welche Broker sie nutzen. Wir speichern die ausgew\u00E4hlten Broker, einen optionalen freien \u201EAndere\u201C-Text mit h\u00F6chstens 80 Zeichen oder die ausdr\u00FCckliche Antwort \u201EIch nutze noch keinen Broker\u201C zusammen mit dem Stockaily-Konto des Mitglieds. Durch die Auswahl wird Stockaily nicht mit dem jeweiligen Broker verbunden. Wir verwenden die Angaben, um das Onboarding zu verbessern und m\u00F6gliche zuk\u00FCnftige Integrationen zu priorisieren. Die Auswertung in der Owner Console erfolgt aggregiert; einzelne Konten werden nicht angezeigt. Die Antwort wird gel\u00F6scht, wenn das zugeh\u00F6rige Stockaily-Konto gel\u00F6scht wird.",
      s2_h: "Wie wir die Daten nutzen",
      s2_b: "Wir verwenden deine Daten ausschlie\u00DFlich, um Stockaily zu betreiben \u2014 dich zu authentifizieren, Analysen auszuf\u00FChren, Quoten durchzusetzen und essenzielle transaktionale E-Mails zu versenden. Wir verkaufen oder vermieten deine Daten nicht.",
      s3_h: "Cookies & lokale Speicherung",
      s3_b: "Wir speichern ein Sitzungstoken und einige nicht trackende Pr\u00E4ferenzen (z.B. Sprache, Watchlist-Status) in deinem Browser. Details findest du in der Cookie-Richtlinie.",
      s4_h: "Deine Rechte",
      s4_b: "Du kannst jederzeit deine personenbezogenen Daten einsehen, korrigieren, exportieren oder l\u00F6schen lassen \u2014 schreib an privacy@stockaily.ai. Wir antworten innerhalb von 30 Tagen.",
      s5_h: "Kontakt",
      s5_b: "Fragen zu dieser Richtlinie? Schreib an privacy@stockaily.ai.",
    },
    terms: {
      title: "Nutzungsbedingungen",
      last_updated: "Mai 2026",
      intro: "Mit der Nutzung von Stockaily stimmst du diesen Bedingungen zu. Sie sind bewusst lesbar gehalten \u2014 melde dich, falls etwas unklar ist.",
      s1_h: "Nur zu Bildungszwecken",
      s1_b: "Stockaily bietet KI-gest\u00FCtzte, p\u00E4dagogische Aktienanalysen. Nichts auf der Plattform stellt eine Anlageberatung, eine Aufforderung zum Kauf/Verkauf von Wertpapieren oder eine Garantie zuk\u00FCnftiger Performance dar. Du allein bist f\u00FCr deine Anlageentscheidungen verantwortlich.",
      s2_h: "Konten",
      s2_b: "Du bist f\u00FCr die Sicherheit deiner Zugangsdaten und f\u00FCr alle Aktivit\u00E4ten unter deinem Konto verantwortlich. Stockaily kann Konten sperren, die gegen diese Bedingungen oder geltendes Recht versto\u00DFen.",
      s3_h: "Abonnement & Abrechnung",
      s3_b: "Pro und Premium werden monatlich oder j\u00E4hrlich \u00FCber CopeCart abgerechnet. Du kannst jederzeit \u00FCber dein Abrechnungs-Dashboard k\u00FCndigen; der Zugriff bleibt bis zum Ende des aktuellen Zeitraums bestehen.",
      s4_h: "Akzeptable Nutzung",
      s4_b: "Reverse-Engineering, Scraping oder Versuche, Ratenlimits oder Feature-Gates zu umgehen, sind untersagt. Nutze Stockaily nicht, um automatisierte Anlageempfehlungen ohne unsere schriftliche Zustimmung an Dritte zu publizieren.",
      s5_h: "Haftung",
      s5_b: "Stockaily wird \"wie besehen\" bereitgestellt. Im gesetzlich zul\u00E4ssigen Rahmen schlie\u00DFen wir die Haftung f\u00FCr indirekte, zuf\u00E4llige oder Folgesch\u00E4den aus der Nutzung der Plattform aus.",
      s6_h: "\u00C4nderungen",
      s6_b: "Wir k\u00F6nnen diese Bedingungen aktualisieren; wesentliche \u00C4nderungen kommunizieren wir per E-Mail. Die fortgesetzte Nutzung von Stockaily nach dem Stichtag gilt als Zustimmung.",
    },
    cookies: {
      title: "Cookie-Richtlinie",
      last_updated: "Mai 2026",
      intro: "Stockaily verwendet eine minimale Anzahl an Cookies und Browser-Speichereintr\u00E4gen \u2014 ausschlie\u00DFlich, um dich angemeldet zu halten, Pr\u00E4ferenzen zu speichern und die Plattform zu betreiben.",
      s1_h: "Strikt notwendig",
      s1_b1: "stockaily_token \u2014 h\u00E4lt dich \u00FCber Sitzungen hinweg angemeldet.",
      s1_b2: "session_token \u2014 serverseitig ausgestelltes Cookie, das deinen Browser mit deinem Konto verkn\u00FCpft.",
      s2_h: "Pr\u00E4ferenzen",
      s2_b1: "stockaily_locale \u2014 merkt sich deine gew\u00E4hlte Sprache (English / Deutsch).",
      s2_b2: "Layout-Pr\u00E4ferenzen (z.B. zuletzt gew\u00E4hlter Chart-Zeitraum) werden lokal gespeichert, damit dein Workflow nahtlos bleibt.",
      s3_h: "Analytik & Tracking",
      s3_b: "Wir binden keine Werbe-Tracker von Drittanbietern ein. Aggregierte, anonymisierte Z\u00E4hler (z.B. wie viele Analysen heute liefen) werden serverseitig berechnet und au\u00DFerhalb unserer Systeme nie mit deiner Identit\u00E4t verkn\u00FCpft.",
      s4_h: "Cookies verwalten",
      s4_b: "Du kannst deine Einwilligungsentscheidungen jederzeit über {cookie_settings} prüfen und ändern. Cookies und den lokalen Speicher kannst du zudem in den Browser-Einstellungen löschen; das Löschen des Sitzungs-Cookies meldet dich ab.",
    },
    impressum: {
      title: "Impressum",
      last_updated: "Mai 2026",
      intro: "Angaben gem\u00E4\u00DF \u00A7 5 DDG (Digitale-Dienste-Gesetz).",
      s1_h: "Betreiber",
      s1_b1: "Stockaily \u2014 KI-gest\u00FCtzte Aktienanalyse-Plattform",
      s1_b2: "Domain: stockaily.ai",
      s1_b3: "Kontakt: support@stockaily.ai",
      s1_b4: "Telefon: +49 40 33483270",
      s2_h: "Verantwortlich f\u00FCr Inhalt",
      s2_b: "Das Stockaily-Team. Die obige Kontaktadresse dient auch f\u00FCr Presseanfragen und inhaltsbezogene Fragen.",
      s3_h: "Online-Streitbeilegung",
      s3_b: "Die Europ\u00E4ische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) unter https://ec.europa.eu/consumers/odr bereit. Wir sind nicht verpflichtet oder bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
      s4_h: "Haftungsausschluss",
      s4_b: "Trotz sorgf\u00E4ltiger inhaltlicher Kontrolle \u00FCbernehmen wir keine Haftung f\u00FCr die Inhalte externer Links. F\u00FCr den Inhalt der verlinkten Seiten sind ausschlie\u00DFlich deren Betreiber verantwortlich.",
      s5_h: "Endg\u00FCltige Gesch\u00E4ftsadresse \u2014 vor Launch zu erg\u00E4nzen",
      s5_b: "Die vollst\u00E4ndige, ladungsf\u00E4hige Gesch\u00E4ftsadresse sowie ggf. Handelsregisternummer und USt-IdNr. werden vor dem \u00F6ffentlichen Launch gem\u00E4\u00DF \u00A7 5 DDG erg\u00E4nzt. Die telefonische Erreichbarkeit ist unter der oben genannten Nummer bereits sichergestellt.",
    },
  },
  dev: {
    label: "Nur Dev",
    test_plan: "Test-Plan",
    test_plan_full: "Nur Dev \u00B7 Test-Plan",
    note: "QA-Bypass \u00B7 vor Production-Launch entfernen.",
    active: "Aktiv",
    plan_free_desc: "10 WL \u00B7 begrenzte KI",
    plan_pro_desc: "Unbegrenzt \u00B7 volle KI",
    plan_premium_desc: "Pro + Portfolio",
    switched_title: "Plan zu {plan} gewechselt",
    switched_desc: "Aktuelle Seite wird neu geladen, damit Zugriffsregeln \u00FCberall gelten.",
    switched_failed: "Plan-Wechsel fehlgeschlagen",
  },

  // Phase 7.UI.7 — Analyze-Seite (zentrale sichtbare Beschriftungen).
  analyze: {
    btn_watchlist: "Watchlist",
    btn_remove: "Entfernen",
    btn_reanalyze: "Neu analysieren",
    chart_price_vs_fair_value: "Kurs vs. fairer Wert",
    growth_revenue: "Umsatz",
    growth_earnings: "Gewinn",
    // Phase 8.LP.POLISH — Deutsche UI-Labels für den
    // Unternehmensprofil-Bereich. Die FMP-Beschreibung selbst
    // bleibt in der Original-Provider-Sprache (i. d. R. Englisch)
    // — wir übersetzen sie NICHT per LLM.
    profile: {
      accordion_title: "Über dieses Unternehmen",
      overview_label: "Unternehmensprofil",
      show_more: "Mehr anzeigen",
      show_less: "Weniger anzeigen",
      row_sector: "Sektor",
      row_industry: "Branche",
      row_exchange: "Börse",
      row_country: "Land",
      row_currency: "Währung",
      row_ceo: "CEO",
      row_employees: "Mitarbeiter",
      row_market_cap: "Marktkapitalisierung",
      row_website: "Website",
    },
    chip_upside: "Potenzial",
    chip_risk: "Risiko",
    chip_horizon: "Horizont",
    inst: {
      classification: "Klassifikation",
      quality_gate: "Qualit\u00E4ts-Check",
      confidence: "Konfidenz",
      methods_used: "Verwendete Methoden",
      risk_regime: "Risikoprofil",
      fair_value_confidence: "Konfidenz im fairen Wert",
      conviction: "{n}% \u00DCberzeugung",
      blended: "{n} kombiniert",
      how_we_got_there: "Wie diese Einsch\u00E4tzung entsteht",
      detected_risks: "Erkannte Risiken",
      summary: "Institutionelle Einsch\u00E4tzung",
    },
    ai: {
      summary: "Zusammenfassung",
      bull: "Bull",
      bear: "Bear",
      risks: "Risiken",
      opportunity: "Chance",
      why_this_score: "Warum dieser Score",
      bull_case: "Bullisches Szenario",
      bear_case: "B\u00E4risches Szenario",
      opportunity_reasoning: "Begr\u00FCndung der Chance",
      key_drivers: "Wichtigste Score-Treiber",
    },
    status: {
      pass: "Bestanden",
      watch: "Beobachten",
      fail: "Durchgefallen",
      high: "Hoch",
      medium: "Mittel",
      low: "Niedrig",
    },
    classification: {
      "SaaS / Software": "SaaS / Software",
      "Bank / Financial": "Bank / Finanzwerte",
      "REIT / Asset-heavy": "REIT / Asset-intensiv",
      "Energy": "Energie",
      "Biotech": "Biotech",
      "Consumer Staples": "Basiskonsumg\u00FCter",
      "Cyclical / Industrial": "Zyklisch / Industrie",
      "Speculative": "Spekulativ",
      "Growth": "Growth",
      "Value": "Value",
    },
    horizon: {
      "Short-term": "Kurz",
      "Mid-term": "Mittel",
      "Long-term": "Lang",
    },
    kpi: {
      market_cap: "Marktkapitalisierung",
      pe: "KGV",
      forward_pe: "Forward-KGV",
      eps: "EPS",
      revenue: "Umsatz",
      revenue_growth: "Umsatzwachstum",
      earnings_growth: "Gewinnwachstum",
      profit_margin: "Gewinnmarge",
      dividend_yield: "Dividendenrendite",
      roic: "ROIC",
      fcf_quality: "FCF-Qualit\u00E4t",
      net_margin: "Nettomarge",
      debt_equity: "Verschuldungsgrad",
      current_ratio: "Liquidit\u00E4t 3. Grades",
      gross_margin: "Bruttomarge",
      operating_margin: "Operative Marge",
      sector_percentile: "Sektor-Rang",
    },
    locked_pro_cap_efficiency: "Pro \u00B7 Kapitaleffizienz",
    locked_pro_balance_sheet: "Pro \u00B7 Bilanzqualit\u00E4t",
    locked_pro_sector_cohort: "vs. Sektor-Kohorte",
    // Hero / ScorePanel
    hero: {
      ai_opportunity_score: "KI-Chancen-Score",
      out_of_100: "/100",
      signal_label: "Signal",
      opportunity_level_label: "Opportunity-Level",
      valuation_label: "Bewertung",
      risk_level_label: "Risikolevel",
      current_price: "Aktueller Kurs",
      fair_value: "Fairer Wert",
      delta_vs_price: "{sign}${amount} vs. Kurs",
      delta_unavailable: "\u0394 vs. Kurs nicht verf\u00FCgbar",
      range: "Spanne ${low} \u2013 ${high}",
      valuation_unavailable: "Bewertung konnte nicht abgeglichen oder verifiziert werden",
      subscore_valuation: "Bewertung",
      subscore_quality: "Unternehmensqualit\u00E4t",
      subscore_growth: "Wachstum",
      subscore_safety: "Risiko & Sicherheit",
    },
    headline: {
      undervalued: "Unterbewertet um {pct}%",
      fairly_valued: "Fair bewertet",
      overvalued: "\u00DCberbewertet um {pct}%",
      unavailable: "Bewertung nicht verf\u00FCgbar",
    },
    signal: {
      opportunity: "Chance",
      neutral: "Neutral",
      risk: "Risiko",
      unavailable: "Nicht verf\u00FCgbar",
    },
    // Pre-launch terminology correction (2026-02-09) — Opportunity
    // Score tier ("Opportunity-Level"), rendered separately from the
    // genuine financial Risk Level.  Thresholds mirror
    // backend/poc/valuation_guards.py:  <45 = Niedrig, 45-74 = Mittel,
    // >=75 = Hoch.
    opportunity_level: {
      low: "Niedrig",
      medium: "Mittel",
      high: "Hoch",
      unavailable: "Nicht verf\u00FCgbar",
    },
    valuation_status: {
      Undervalued: "Unterbewertet",
      Fair: "Fair",
      Overvalued: "\u00DCberbewertet",
      Unavailable: "Nicht verf\u00FCgbar",
      unavailable: "Nicht verf\u00FCgbar",
    },
    classification: {
      top_opportunity: "Top-Chance",
      opportunity: "Chance",
      fair: "Fair bewertet",
      neutral: "Fair bewertet",
      risk: "Risiko",
      unavailable: "Nicht verf\u00FCgbar",
    },
    valuation_unavailable: {
      title_unreconciled: "Bewertung f\u00FCr {ticker} nicht verf\u00FCgbar",
      title_outlier: "Bewertung f\u00FCr {ticker} konnte nicht verifiziert werden",
      message_unreconciled_fallback:
        "Die Berichtsw\u00E4hrung und die Aktien-Einheiten dieses Titels konnten nicht mit dem Marktkurs abgeglichen werden. Stockaily zeigt nur Bewertungen, die es begr\u00FCnden kann \u2013 daher werden f\u00FCr diese Analyse kein fairer Wert, kein Auf-/Abw\u00E4rtspotenzial und kein Opportunity Score angezeigt.",
      message_outlier_fallback:
        "Der berechnete faire Wert ist ein extremer Ausrei\u00DFer gegen\u00FCber dem aktuellen Marktkurs und konnte nicht unabh\u00E4ngig verifiziert werden. Stockaily h\u00E4lt unverifizierte Extremwerte zur\u00FCck, statt einen m\u00F6glicherweise irref\u00FChrenden Wert anzuzeigen.",
    },
    snapshot: {
      title: "Institutionelle Einsch\u00E4tzung",
      phase_badge: "Phase 2",
      fundamental_composite: "Fundamental Composite",
      composite_tip_title: "Fundamental Composite",
      composite_tip_intro: "Zeigt, wie stark das Unternehmen rein fundamental wirkt. Er kombiniert Bewertung, Unternehmensqualit\u00E4t, Wachstum und Risiko/Sicherheit zu einem Diagnosewert. Das ist <b>nicht</b> dasselbe wie der AI Opportunity Score.",
      composite_relation_title: "Wie er sich vom AI Opportunity Score unterscheidet:",
      composite_relation_ai: "<b>AI Opportunity Score</b> = das finale Aktiensignal f\u00FCr den Nutzer. Er ber\u00FCcksichtigt zus\u00E4tzlich Bewertungsspielraum, Risiko, Vertrauen, Sektor-Kontext und Sicherheitsregeln.",
      composite_relation_fc: "<b>Fundamental Composite</b> = die fundamentale Ebene hinter dem Score. Er hilft zu erkl\u00E4ren, warum der AI Opportunity Score so ausgefallen ist.",
      weights_label: "Gewichtung:",
      weight_valuation: "Bewertung 35%",
      weight_quality: "Unternehmensqualit\u00E4t 30%",
      weight_growth: "Wachstum 20%",
      weight_risk: "Risk & Safety 15%",
      breakdown_valuation: "Bewertung",
      breakdown_quality: "Unternehmensqualit\u00E4t",
      breakdown_growth: "Wachstum",
      breakdown_risk: "Risk & Safety",
      breakdown_trend: "Trend-Anpassung",
      subtitle: "Deterministische, regelbasierte Analyse, angepasst an den Unternehmenstyp.",
      tap_to_learn: "Tippe auf eine Kachel, um zu erfahren, was sie bedeutet.",
      veto_hard_label: "Hartes Veto \u2014 Score auf 35 begrenzt",
      veto_soft_label: "Weiches Veto \u2014 Score auf 55 begrenzt",
      veto_hard_badge: "Erzwungenes Risiko",
      veto_soft_badge: "Chance blockiert",
      value_trap_label: "Value-Trap-Risiko",
      detected_risks: "Wichtigste erkannte Risiken",
      methods_used_label: "Verwendete Methoden",
      method_fair_value: "Fairer Wert",
      method_weight: "Gewichtung",
      method_confidence: "Konfidenz",
      method_proxied: "Nutzt N\u00E4herungswerte:",
      // Deterministic 'How we got there' templates (frontend-rendered for DE)
      reasoning_classified: "Als {label} klassifiziert \u2014 Bewertungsmethoden entsprechend angepasst.",
      reasoning_blended: "Fairer Wert abgeleitet aus: {methods}.",
      reasoning_upside: "Impliziertes Aufw\u00E4rtspotenzial von {pct}% gegen\u00FCber dem aktuellen Kurs ({confidence} Konfidenz).",
      reasoning_downside: "Impliziertes Abw\u00E4rtspotenzial von {pct}% gegen\u00FCber dem aktuellen Kurs ({confidence} Konfidenz).",
      reasoning_quality_gate: "Qualit\u00E4ts-Check: {status} \u2014 {reason}.",
      reasoning_quality_no_flags: "keine Auff\u00E4lligkeiten",
      reasoning_risk_regime: "Risikoprofil: {regime} \u2014 {reason}.",
      reasoning_hard_veto: "HARTES VETO: {label} \u2014 Score auf 35 begrenzt; Klassifikation auf Risiko gesetzt.",
      reasoning_soft_veto: "Weiches Veto: {label} \u2014 Score auf 55 begrenzt; Chancen-Klassifikation blockiert.",
      reasoning_value_trap: "Value-Trap-Risiko: {warning}",
      reasoning_confidence_overall: "Gesamtkonfidenz: {label} ({score}%).",
      // Method name translations
      method_names: {
        "DCF": "DCF",
        "Sector P/E": "Sektor-KGV",
        "EV/ARR (SaaS)": "EV/ARR (SaaS)",
        "Price/Book": "Kurs/Buchwert",
        "Dividend Yield Anchor": "Dividendenrendite-Anker",
        "EV/EBITDA": "EV/EBITDA",
        "Price/FFO": "Kurs/FFO",
        "Risk-Adjusted Anchor": "Risiko-adjustierter Anker",
      },      // Quality gate reasons (best-effort common patterns)
      quality_reasons: {
        "No material quality concerns detected": "Keine wesentlichen Qualit\u00E4tsbedenken erkannt",
        "Persistent negative free cash flow": "Anhaltend negativer Free Cashflow",
        "Persistent net losses": "Anhaltende Nettoverluste",
        "Negative shareholder equity": "Negatives Eigenkapital",
        "Weak return on invested capital": "Schwache Kapitalrendite (ROIC)",
        "Declining margins": "R\u00FCckl\u00E4ufige Margen",
      },
      risk_category: {
        valuation: "Bewertung",
        balance_sheet: "Bilanz",
        operational: "Operativ",
        capital_structure: "Kapitalstruktur",
        external: "Extern",
        other: "Sonstige",
      },
      tile_tips: {
        classification_title: "Unternehmensklassifikation",
        classification_body: "Wir klassifizieren das Unternehmen anhand von Sektor, Branche und Finanzprofil. Unterschiedliche Typen (SaaS, Bank, REIT, Zykliker etc.) erhalten unterschiedliche Bewertungsmethoden, weil das, was eine Bank g\u00FCnstig macht, sich stark von dem unterscheidet, was eine SaaS-Firma g\u00FCnstig macht.",
        gate_title: "Qualit\u00E4ts-Check",
        gate_body: "Pass / Beobachten / Durchgefallen \u2014 basierend auf harten Fundamentaldaten: dauerhafte Verluste, negativer Cashflow, negatives Eigenkapital, schwacher ROIC. Ein Durchfall begrenzt den Score unabh\u00E4ngig von der Bewertung \u2014 selbst ein 'g\u00FCnstiges' schwaches Unternehmen bleibt riskant.",
        confidence_title: "Analyse-Konfidenz",
        confidence_body: "Kombiniert Vollst\u00E4ndigkeit der Eingabedaten, Konsistenz unserer Bewertungsmethoden und einen kleinen Abschlag f\u00FCr gesch\u00E4tzte/proxy-basierte Kennzahlen oder Sektor-Mediane. Bereich 25\u201395%. Hoch >70% / Mittel 45\u201370% / Niedrig <45%.",
        methods_title: "Multi-Methoden-Bewertung",
        methods_body: "Statt eines einzelnen DCF nutzen wir mehrere Bewertungsmethoden, die zum Unternehmenstyp passen \u2014 z.B. EV/ARR f\u00FCr SaaS, KBV f\u00FCr Banken, FFO f\u00FCr REITs \u2014 und gewichten sie. So verzerrt eine einzelne fehlerhafte Annahme nicht das Ergebnis.",
        risk_regime_title: "Risikoprofil",
        risk_regime_body: "Niedrig / Mittel / Hoch basierend auf Volatilit\u00E4t (Beta), Verschuldung, Profitabilit\u00E4t und der Klassifikation selbst. Hochrisikofirmen werden auf moderate Scores begrenzt \u2014 sie k\u00F6nnen nicht als klare Chance gelten, selbst wenn die Mathematik 'g\u00FCnstig' sagt.",
        fv_confidence_title: "Fair-Value-Sicherheit",
        fv_confidence_body: "Zeigt, wie verl\u00E4sslich die Fair-Value-Sch\u00E4tzung ist. <b>Hohe</b> Sicherheit bedeutet, dass die Bewertungssignale konsistent sind und die gesch\u00E4tzte Spanne relativ eng ist. <b>Mittlere</b> Sicherheit bedeutet, dass die Sch\u00E4tzung nutzbar ist, aber einige Signale gemischt sind. <b>Niedrige</b> Sicherheit bedeutet, dass die Bewertungsspanne gro\u00DF ist oder die Eingaben weniger eindeutig sind. Niedrige Sicherheit hei\u00DFt nicht automatisch, dass die Aktie schlecht ist. Sie bedeutet, dass die Fair-Value-Sch\u00E4tzung unsicherer ist.",
      },
    },
    // Phase 8.LP.TIPS — Tooltips für die vier Fundamental-Teilscore-
    // Balken der Analyse. Der Label "Risk & Safety" bleibt als
    // Produktbegriff auch im deutschen UI in Englisch.
    subscore_tips: {
      valuation_title: "Bewertung",
      valuation_body: "Misst, wie attraktiv die Aktie im Vergleich zum gesch\u00E4tzten fairen Wert und zu Bewertungskennzahlen wirkt. H\u00F6her = g\u00FCnstiger oder attraktiver bewertet. Niedriger = teurer oder weniger attraktiv bewertet.",
      quality_title: "Unternehmensqualit\u00E4t",
      quality_body: "Misst die Qualit\u00E4t des Gesch\u00E4ftsmodells. Ber\u00FCcksichtigt Profitabilit\u00E4t, Margen, Cashflow-Qualit\u00E4t, Bilanzst\u00E4rke und Kapitalrendite. H\u00F6her = st\u00E4rkere Unternehmensqualit\u00E4t.",
      growth_title: "Wachstum",
      growth_body: "Misst, wie stark das Unternehmen w\u00E4chst. Ber\u00FCcksichtigt Umsatzwachstum, Gewinnwachstum und weitere Wachstumssignale, wenn verf\u00FCgbar. H\u00F6her = st\u00E4rkeres Wachstumsprofil.",
      safety_title: "Risk & Safety",
      safety_body: "Misst finanzielles Risiko und Stabilit\u00E4t. Ber\u00FCcksichtigt Bilanzst\u00E4rke, Verschuldung, Volatilit\u00E4t und Risikosignale. H\u00F6her = sichereres Profil. Niedriger = h\u00F6heres Risiko.",
      ai_score_title: "AI Opportunity Score",
      ai_score_body: "Der AI Opportunity Score ist Stockailys finales Aktiensignal. Er kombiniert Bewertungsspielraum, Unternehmensqualit\u00E4t, Wachstum, Risiko, Vertrauen und Sektor-Kontext. H\u00F6here Werte zeigen eine attraktivere Chance laut Modell.",
    },
    drivers: {
      title: "Wichtigste Score-Treiber",
      subtitle: "Basierend auf Cashflow-, Bewertungs-, Profitabilit\u00E4ts-, Wachstums- und Bilanzanalyse.",
      tap_hint: "Tippe auf eine Kennzahl, um zu erfahren, was sie bedeutet.",
      label: {
        fcf_yield: "FCF-Rendite",
        cash_flow_quality: "Cashflow-Qual.",
        roic: "ROIC",
        revenue_growth: "Wachstum",
        pe_vs_sector: "KGV/Sektor",
        debt_to_equity: "Verschuldung",
        fair_value_confidence: "FV-Konfidenz",
      },
      tip: {
        fcf_yield_title: "Free-Cashflow-Rendite",
        fcf_yield_body: "Wie viel echtes Bargeld das Unternehmen relativ zu dem produziert, was Investoren daf\u00FCr zahlen. \u00DCber 4% ist attraktiv \u2014 das hei\u00DFt, das Gesch\u00E4ft ist g\u00FCnstig im Verh\u00E4ltnis zum erzeugten Cash.",
        cash_flow_quality_title: "FCF-Qualit\u00E4t",
        cash_flow_quality_body: "<b>Was es ist</b><br/>Zeigt, wie gut ausgewiesene Gewinne in echten freien Cashflow umgewandelt werden.<br/><br/><b>Warum es wichtig ist</b><br/>Starke Cashflow-Qualit\u00E4t bedeutet, dass Gewinne durch echte Cash-Generierung gest\u00FCtzt sind und nicht nur durch Buchhaltungseffekte.<br/><br/><b>Faustregel</b><br/>80\u2013100 = stark<br/>60\u201379 = solide<br/>40\u201359 = gemischt<br/>Unter 40 = schwach oder h\u00F6heres Risiko",
        roic_title: "Kapitalrendite (ROIC)",
        roic_body: "Wie viel Gewinn das Unternehmen pro investiertem Kapital erwirtschaftet. Top-Compounder liegen \u00FCber 15%. Unter 8% bedeutet, dass das Unternehmen Schwierigkeiten hat, Werte aus seinem Verm\u00F6gen zu schaffen.",
        revenue_growth_title: "Umsatzwachstumsdynamik",
        revenue_growth_body: "Wie schnell der Umsatz im Jahresvergleich w\u00E4chst. \u00DCber 15% ist starkes Wachstum. 5\u201315% ist solide. Stagnation oder R\u00FCckgang deutet oft auf Wettbewerbs- oder Nachfragedruck hin.",
        pe_vs_sector_title: "KGV vs. Sektor",
        pe_vs_sector_body: "Kurs-Gewinn-Verh\u00E4ltnis im Vergleich zu Peers im selben Sektor. Unter 1,0\u00D7 hei\u00DFt: g\u00FCnstiger als die Branche. \u00DCber 1,2\u00D7 hei\u00DFt: Anleger zahlen einen Aufpreis, den zuk\u00FCnftiges Wachstum rechtfertigen muss.",
        debt_to_equity_title: "Verschuldungsprofil",
        debt_to_equity_body: "Gesamtschulden geteilt durch Eigenkapital. Unter 1\u00D7 ist konservativ und robust. \u00DCber 2\u00D7 bedeutet hohe Hebelwirkung, die Verluste in Abschw\u00FCngen oder bei steigenden Zinsen verst\u00E4rkt.",
        fair_value_confidence_title: "Fair-Value-Sicherheit",
        fair_value_confidence_body: "Zeigt, wie verl\u00E4sslich die Fair-Value-Sch\u00E4tzung ist. <b>Hohe</b> Sicherheit bedeutet, dass die Bewertungssignale konsistent sind und die gesch\u00E4tzte Spanne relativ eng ist. <b>Mittlere</b> Sicherheit bedeutet, dass die Sch\u00E4tzung nutzbar ist, aber einige Signale gemischt sind. <b>Niedrige</b> Sicherheit bedeutet, dass die Bewertungsspanne gro\u00DF ist oder die Eingaben weniger eindeutig sind. Niedrige Sicherheit hei\u00DFt nicht automatisch, dass die Aktie schlecht ist. Sie bedeutet, dass die Fair-Value-Sch\u00E4tzung unsicherer ist.",
      },
    },
    chart: {
      title: "Kurs vs. fairer Wert",
      subtitle: "Zukunftsgerichtete Projektion \u00B7 g\u00FCnstige Zone (gr\u00FCn) unterhalb der Kurve, teure Zone (rot) oberhalb.",
      info_aria: "\u00DCber diese Fair-Value-Kurve",
      info_body: "Diese Kurve zeigt einen gesch\u00E4tzten fairen Wert auf Basis aktueller Fundamentaldaten und projizierten Wachstums \u2014 sie ist keine historische Neuberechnung. Der faire Wert ver\u00E4ndert sich im Zeitverlauf; dies ist eine zukunftsgerichtete Sch\u00E4tzung.",
      overlay_toggle: "Fair-Value-Overlay anzeigen",
      legend_cheap: "G\u00FCnstige Zone",
      legend_expensive: "Teure Zone",
      legend_fair_value: "Fairer Wert (projiziert)",
      legend_fair_value_short: "Fairer Wert",
      legend_current_price: "Aktueller Kurs",
      legend_footnote: "Der faire Wert ver\u00E4ndert sich im Zeitverlauf \u2014 dies ist eine zukunftsgerichtete Sch\u00E4tzung.",
      last_5_years: "Letzte 5 Jahre",
      tooltip_price: "Kurs",
      tooltip_fair_value: "Fairer Wert",
      verdict_undervalued: "Unterbewertet um +{pct}%",
      verdict_fair: "Fair bewertet",
      verdict_overvalued: "\u00DCberbewertet um {pct}%",
      now_pill: "JETZT",
      fair_value_pill: "FAIRER WERT",
      fallback_plan_restricted: "Historische Chart-Daten sind im aktuellen Datentarif nicht verf\u00FCgbar",
      fallback_rate_limited: "Historische Chart-Daten sind vor\u00FCbergehend ratenbeschr\u00E4nkt",
      fallback_empty: "F\u00FCr dieses Symbol wurden keine historischen Kurspunkte zur\u00FCckgegeben",
      fallback_unavailable: "Historische Chart-Daten sind vor\u00FCbergehend nicht verf\u00FCgbar",
      fallback_secondary: "Die Bewertungs\u00FCbersicht und alle anderen Analyse-Bereiche bleiben korrekt; nur der historische Kurschart fehlt.",
      overlay_label_mobile: "Fair-Value-Overlay",
      microexplanation_desktop: "Die gr\u00FCne Kurve ist eine <strong>gesch\u00E4tzte Fair-Value-Projektion</strong>, basierend auf aktuellen Fundamentaldaten (Cashflow, Bewertung, Wachstum) extrapoliert mit einer stabilen j\u00E4hrlichen Wachstumsannahme \u2014 sie ist keine historische Neuberechnung des fairen Werts. Liegt der Kurs unter der Kurve, ist die Aktie in der g\u00FCnstigen Zone; \u00FCber der Kurve in der teuren Zone.",
      microexplanation_mobile: "Die gr\u00FCne Kurve ist eine <strong>zukunftsgerichtete Fair-Value-Projektion</strong> \u2014 darunter liegt die g\u00FCnstige Zone, dar\u00FCber die teure Zone.",
    },
    ai_extra: {
      panel_title: "KI-Einblicke",
      free_preview_badge: "FREE-VORSCHAU",
      generating_badge: "WIRD ERSTELLT",
      generating_label: "KI-Einblicke werden erstellt\u2026",
      generating_timed_out: "KI-Einblicke werden noch erstellt. Sie erscheinen automatisch, sobald sie bereit sind.",
      generating_footnote: "Bewertung, Score und KPIs oben sind bereits final. Die vollst\u00E4ndige KI-Analyse wird im Hintergrund vorbereitet.",
      free_upgrade_blurb: "Upgrade f\u00FCr KI-Recherche auf institutionellem Niveau, Bull-/Bear-Cases und Risikoanalyse.",
      upgrade_btn: "Upgrade",
      locked_pro_tab_hint: "Verf\u00FCgbar mit Pro. Upgrade, um diesen Bereich freizuschalten.",
      locked_teaser_eyebrow: "Pro-Insights Vorschau",
      locked_teaser_body:
        "Upgrade, um den vollst\u00E4ndigen Bull Case, Bear Case, die wichtigsten Risiken, die Konfidenz-Begr\u00FCndung und die Score-Erkl\u00E4rung freizuschalten \u2014 als KI-Narrativ auf institutionellem Niveau f\u00FCr diese Aktie.",
      no_risks: "Keine wesentlichen Risiken identifiziert.",
      no_items: "Keine Eintr\u00E4ge identifiziert.",
      drivers_positive: "Was funktioniert",
      drivers_negative: "Was den Score belastet",
      section_top_risks: "Wichtigste institutionelle Risiken",
      section_confidence: "Warum unsere Konfidenz auf diesem Niveau liegt",
      section_drivers: "Warum diese Aktie so bewertet wird",
      ai_paused_banner: "KI-Kommentar ist kurz pausiert. Bewertung und KPIs bleiben korrekt.",
      disclaimer_not_advice: "Dies ist keine Finanzberatung.",
    },
    // Phase 8.LP.FLE — Free-Kontingent ersch\u00F6pft, Locked-Preview.
    locked_preview: {
      headline: "Free-Analyse-Limit erreicht",
      subheadline: "Du hast alle {used} von {limit} kostenlosen Analysen in diesem Zeitraum verbraucht.",
      reset_with_date: "Deine n\u00E4chsten kostenlosen Analysen werden am {date} freigeschaltet.",
      reset_generic: "Dein kostenloses Analyse-Kontingent wird mit deinem rollierenden 30-Tage-Zeitraum zur\u00FCckgesetzt.",
      upgrade_line: "Upgrade auf Pro f\u00FCr unbegrenzte Analysen und sofortigen Vollzugriff.",
      cta_primary: "Upgrade auf Pro",
      cta_secondary: "Tarife ansehen",
      disclaimer: "Bildungsorientiertes Bewertungstool. Keine Finanzberatung.",
      locked_label: "Gesperrt",
      sections: {
        fair_value: {
          title: "Stockaily Fair Value",
          hint: "Unsere modellbasierte Sch\u00E4tzung des inneren Werts.",
        },
        opportunity_score: {
          title: "Opportunity Score",
          hint: "0\u2013100 Composite-Signal aus Bewertung, Qualit\u00E4t und Risiko.",
        },
        upside_downside: {
          title: "Upside / Downside",
          hint: "Differenz zwischen Fair Value und aktuellem Kurs.",
        },
        bull_case: {
          title: "Bull Case",
          hint: "Die st\u00E4rksten Argumente f\u00FCr diese Aktie.",
        },
        bear_case: {
          title: "Bear Case",
          hint: "Die st\u00E4rksten Argumente gegen diese Aktie.",
        },
        key_risks: {
          title: "Wichtige Risiken",
          hint: "Gesch\u00E4fts-, Bewertungs- und Finanzrisiken, die das Modell identifiziert.",
        },
        ai_narrative: {
          title: "Vollst\u00E4ndige KI-Analyse",
          hint: "Institutionelle KI-Erz\u00E4hlung, die die Bewertung erkl\u00E4rt.",
        },
        valuation_breakdown: {
          title: "Bewertungs-Breakdown",
          hint: "Multi-Methoden-Bewertung mit Sensitivit\u00E4t pro Methode.",
        },
      },
    },
    kpi_tip: {
      what_label: "Was es ist \u2014 ",
      why_label: "Warum es wichtig ist \u2014 ",
      rule_label: "Faustregel \u2014 ",
    },
    risk_chip: {
      forced: "Erzwungenes Risiko",
      blocked: "Chance blockiert",
    },
    session: {
      waiting_title: "Warte auf Sitzung",
      waiting_body: "Wir verifizieren dein Konto, damit wir die {ticker}-Analyse starten k\u00F6nnen. Dauert meist unter 2 Sekunden.",
    },
    unavailable: {
      title: "Daten f\u00FCr {ticker} nicht verf\u00FCgbar",
      message_fallback: "Wir konnten gerade keine Live-Marktdaten f\u00FCr dieses Ticker abrufen. Das ist meist ein vor\u00FCbergehendes Problem beim Datenanbieter \u2014 bitte versuche es in einigen Minuten erneut.",
      try_again: "Erneut versuchen",
      pick_different: "Anderes Ticker w\u00E4hlen",
    },
    limit: {
      title: "Du hast dein kostenloses Analysenkontingent erreicht.",
      subtitle: "Upgrade auf Pro f\u00FCr unbegrenzte Analysen und volle KI-Einblicke.",
      upgrade_cta: "Upgrade",
    },
    sparse: {
      title: "Begrenzte Fundamentaldaten f\u00FCr {ticker}",
      body: "Wir konnten nur einen Teil der Finanz-Endpunkte f\u00FCr diese Aktie abrufen \u2014 die KI-Analyse und Bewertung unten ist daher m\u00F6glicherweise weniger verl\u00E4sslich als sonst. Fehlende Werte zeigen wir als \u2014 anstelle von Nullen, damit Signale ehrlich bleiben. Wir versuchen es weiter, sobald die Datenabdeckung steigt.",
    },
    auth: {
      log_in_cta: "Anmelden",
      create_account_cta: "Konto erstellen",
      gate_title: "Anmelden, um {ticker} zu analysieren",
      gate_subtitle: "Stockaily verfolgt dein kostenloses Kontingent in deinem Konto. Melde dich an oder erstelle eines, um KI-Bewertungen zu starten.",
      session_expired_toast: "Sitzung abgelaufen \u2014 bitte erneut anmelden.",
    },
    // Slice 1 (2026-02-14) — anonyme Analyse-Sperre.
    anonymous_gate: {
      title: "Erstelle ein kostenloses Konto, um {ticker} zu analysieren",
      body: "Erhalte den gesch\u00E4tzten Fair Value, Opportunity Score, das Aufw\u00E4rts-/Abw\u00E4rtspotenzial und die Risikoanalyse in weniger als 30 Sekunden.",
      primary_cta: "Kostenloses Konto erstellen",
      secondary_cta: "Einloggen",
      microcopy: "10 kostenlose Analysen im ersten Monat. Keine Kreditkarte erforderlich.",
    },
    not_found: {
      head_unsupported: "Nicht unterst\u00FCtztes Asset",
      head_timeout: "Analyse hat zu lange gedauert",
      head_session_expired: "Sitzung abgelaufen",
      head_error: "Etwas ist schiefgelaufen",
      head_default: "Aktie nicht gefunden",
      body_unsupported: "Stockaily unterst\u00FCtzt derzeit nur Aktienanalysen. \u201E{ticker}\u201C sieht aus wie eine Kryptow\u00E4hrung, ein W\u00E4hrungspaar oder ein Futures-Kontrakt \u2014 keine davon passen zu unserer aktienfokussierten Bewertungs-Engine (DCF, ROIC, KGV, Bilanzqualit\u00E4t).",
      body_timeout: "Der Analyse-Service ben\u00F6tigt l\u00E4nger als erwartet. Das l\u00F6st sich meist in wenigen Sekunden. Versuche es erneut oder w\u00E4hle unten ein anderes Ticker.",
      body_session_expired: "Deine Sitzung ist abgelaufen. Bitte erneut anmelden, um {ticker} zu analysieren.",
      body_error: "Unsere Analyse-Engine hatte einen unerwarteten Fehler. Versuche es in einem Moment erneut oder w\u00E4hle unten ein anderes Ticker.",
      body_default: "Wir konnten \u201E{ticker}\u201C nicht in unserer Datenbank finden. Pr\u00FCfe die Schreibweise oder versuche das Tickerk\u00FCrzel statt des Firmennamens.",
      this_stock: "diese Aktie",
      sign_in_continue: "Anmelden, um fortzufahren",
      back_after_signin: "Du wirst nach der Anmeldung zur\u00FCck zu {ticker} geleitet.",
      back_after_signin_default: "der Analyseseite",
      search_placeholder_unsupported: "Versuche ein Aktienticker oder einen Firmennamen\u2026",
      search_placeholder_default: "Versuche ein anderes Ticker oder einen anderen Firmennamen\u2026",
      tip_unsupported_html: "Stockaily analysiert <span class=\"text-foreground/90\">b\u00F6rsennotierte Aktien</span> \u2014 Aktien, ADRs und ETFs.",
      tip_default_html: "Tipp: <span class=\"text-foreground/90\">Tickerk\u00FCrzel</span> (wie AAPL, MSFT) funktionieren meist besser als Firmennamen.",
      suggestions_unsupported: "Versuche stattdessen diese Aktien",
      suggestions_default: "Beliebte Ticker",
      go_back: "Zur\u00FCck",
    },
  },

  // Phase 7.UI.10 — AI Alpha Signals.
  signals: {
    title: "KI-Alpha-Signale",
    subtitle: "Mustererkennung auf institutionellem Niveau f\u00FCr {ticker} \u2014 Risikohinweise, Edge-Signale und Sektorkontext.",
    full_access: "Vollzugriff",
    cta_title: "Schalte die restliche KI-Analyse frei",
    cta_subtitle: "Vollst\u00E4ndige Risikoaufschl\u00FCsselung, Szenariomodellierung und Sektor-Rang \u2014 ohne Limits.",
    cta_see_plans: "Pl\u00E4ne ansehen",
    cta_upgrade: "Auf Pro upgraden",
    items: {
      value_trap: {
        title: "Potenzielles Value-Trap-Risiko erkannt",
        preview: "Die Aktie wirkt {upside_abs}% g\u00FCnstig, aber unser Modell sieht",
        locked: "sich verschlechternde Cash-Conversion (FCF/Nettogewinn {fcf_to_ni}), schrumpfende Margen und Bilanzschw\u00E4che \u2014 die KI liest dies als strukturelle, nicht zyklische Unterbewertung.",
      },
      earnings_quality: {
        title: "Warnung zur Ertragsqualit\u00E4t",
        preview: "Berichtete Gewinne liegen vor dem Cashflow um",
        locked: "ca. {gap_pct}% \u2014 ein Muster, das historisch mit accrual-getriebenen \u00DCberraschungen und Gewinnnormalisierung innerhalb von 4\u20136 Quartalen einhergeht.",
      },
      multiple_compression: {
        title: "Risiko einer Sektor-Multiple-Kompression",
        preview: "Notiert mit Aufschlag zum Sektor-KGV; eine Mean-Reversion impliziert",
        locked: "ein {comp_pct}%-Multiple-Kompressionsszenario \u00FCber 18\u201324 Monate \u2014 das w\u00FCrde den Gro\u00DFteil des Upsides aus dem Gewinnwachstum aufzehren.",
      },
      balance_sheet: {
        title: "KI hat verstecktes Bilanzrisiko erkannt",
        preview: "Verschuldungsgrad bei {de}x und Nettoverschuldung bei {nd_to_mc_pct} der Marktkapitalisierung deuten auf",
        locked: "enge Kreditkonditionen in einem Zinsumfeld hin. Ein Stresstest mit +200bp Zinsschock entfernt in unserem Modell ca. 14\u201322% des Eigenkapitalwerts.",
      },
      low_confidence: {
        title: "Niedrige Bewertungskonfidenz",
        preview: "Die Bewertungsspanne ist ungew\u00F6hnlich breit, da",
        locked: "das Cashflow-Profil spekulativ ist und die langfristige Wirtschaftlichkeit nur begrenzt sichtbar ist. Die KI empfiehlt eine Positionsgr\u00F6\u00DFe rund 40% unter normaler \u00DCberzeugung.",
      },
      quality_value_alignment: {
        title: "Hohe Qualit\u00E4ts- und Value-\u00DCbereinstimmung",
        preview: "Qualit\u00E4ts- und Bewertungs-Subscores liegen beide im oberen Quartil \u2014",
        locked: "eine Konstellation, die den Sektor in unserem Backtest-Universum \u00FCber 3-j\u00E4hrige Halteperioden historisch um ca. 6\u20139% p.a. \u00FCbertroffen hat.",
      },
      growth_durability: {
        title: "Robustes Wachstumsprofil erkannt",
        preview: "Umsatz-, Gewinn- und FCF-Wachstum liegen alle im obersten Dezil,",
        locked: "mit internen Compounding-Signalen, die auf einen 3-Jahres-Anstieg des inneren Werts auf ca. das 1,4\u20131,7-fache des aktuellen fairen Werts hindeuten.",
      },
      neutral_baseline: {
        title: "Bewertung liegt eng um den fairen Wert",
        preview: "Der modellierte faire Wert liegt im Rauschband des Kurses \u2014",
        locked: "die KI sieht kein asymmetrisches Setup. Pro-Mitglieder sehen den Sektor-Rang, die historische Signalgenauigkeit und das vollst\u00E4ndige Subscore-Kommentar.",
      },
      sector_percentile: {
        title: "Sektor-Rang",
        preview: "Der KI-Chancen-Score dieser Aktie liegt im",
        locked: "oberen {top_pct}%-Bereich der von Stockaily beobachteten {sector}-Werte \u2014 Pro zeigt Live-Perzentile gegen\u00FCber den 5 \u00E4hnlichsten Peers und die historische Genauigkeit dieses Signals.",
      },
    },
  },
  theme: {
    label: "Theme",
    dark: "Dunkel",
    light: "Hell",
    switch_to_dark: "Zu Dunkelmodus wechseln",
    switch_to_light: "Zu Hellmodus wechseln",
  },
  portfolio: {
    page: {
      title: "Portfolio Intelligence",
      subtitle: "Verfolge deine Positionen anhand des Fair Value, Opportunity Score\nund Risikoprofils von Stockaily.",
      disclaimer: "Stockaily bietet ein Bildungs-Bewertungstool und keine Anlageberatung.",
    },
    common: {
      loading: "Portfolio wird geladen…",
      pending: "Analyse ausstehend",
    },
    review: {
      title: "Portfolio-KI-Analyse",
      summary: "Zusammenfassung",
      strengths: "Stärken",
      weaknesses: "Schwächen",
      risks: "Risiken",
      concentration: "Konzentrationsrisiken",
      top_opportunity: "Top-Chance",
      largest_risk: "Größtes Bewertungsrisiko",
      research_priorities: "Research-Prioritäten",
      confidence: "Konfidenz",
      updated_at: "Aktualisiert",
      cta_analyze: "Portfolio analysieren",
      cta_update: "Portfolioanalyse aktualisieren",
      cta_running: "Analyse wird erstellt…",
      badge_premium_ai: "Premium-KI",
      disclaimer: "Bildungsanalyse — keine Anlageberatung.",
    },
    tooltip: {
      portfolio_value: "Gesamter aktueller Marktwert aller Positionen zu den jeweils zuletzt verfügbaren Kursen.",
      estimated_fair_value: "Summe aus Anteilen × Stockaily-Fair-Value aller Positionen.",
      portfolio_upside: "(Geschätzter Fair Value − Portfoliowert) / Portfoliowert. Positiv = Buch handelt unter dem geschätzten Fair Value.",
      unrealized_pl: "Unrealisierter Gewinn oder Verlust gegenüber dem gewichteten Durchschnittskaufpreis. Verkaufte Positionen sind nicht enthalten.",
      weighted_opportunity_score: "Positionsgewichteter Stockaily-Opportunity-Score auf einer Skala von 0–100. Höher ist attraktiver.",
      risk_level: "Risiko und Bewertung sind getrennte Dimensionen. Eine Aktie kann unterbewertet erscheinen und trotzdem ein hohes Risiko haben, etwa durch Schulden, Volatilität, geringe Fair-Value-Konfidenz oder geschäftliche Unsicherheit.",
      position_weight: "Anteil dieser Position am gesamten Marktwert des Portfolios.",
      fair_value: "Stockaily-Schätzung des Fair Value auf Basis des deterministischen Bewertungsmodells.",
      ai_score: "Stockaily-Opportunity-Score für diese Position auf einer Skala von 0–100.",
      concentration: "Größter Einzelpositionsanteil im Portfolio. Hohe Konzentration erhöht das idiosynkratische Risiko.",
      top_opportunity: "Position mit der besten Kombination aus Upside und Score, hervorgehoben zur weiteren Recherche.",
      largest_valuation_risk: "Position, die im Vergleich zum geschätzten Fair Value am stärksten überbewertet erscheint.",
      shares: "Anzahl Ihrer Anteile. Bruchteile bis zu 6 Nachkommastellen werden unterstützt.",
      average_buy_price: "Anteilsgewichteter durchschnittlicher Kaufpreis pro Anteil über alle BUY-Transaktionen für dieses Ticker.",
    },
    risk: { low: "Niedrig", medium: "Mittel", high: "Hoch" },
    kpi: {
      value: "Portfolio-Wert",
      estimated_fair_value: "Geschätzter Fair Value",
      upside_downside: "Upside / Downside",
      upside_downside_hint: "Geschätzter ggü. aktuellem Portfolio-Wert",
      unrealized_pl: "Unrealisierter G/V",
      weighted_score: "Gewichteter Opportunity Score",
      weighted_score_hint: "Wertgewichtet über alle Positionen",
      risk_level: "Risiko",
      risk_hint: "Wertgewichtet über alle Positionen",
      unrealized_pl_hint_pending: "Wartet auf Live-Preise",
      cost_basis: "Einstand",
      vs_value: "vs aktueller Wert",
      coverage_partial_badge: "Teilweise",
      coverage_partial_short_label: "{count}/{total} Positionen",
      coverage_partial_notice: "Angezeigter Fairer Wert deckt {count} von {total} Positionen ({ratio} des Portfolio-Marktwerts) ab \u2014 nicht das gesamte Portfolio.",
      coverage_partial_label: "Deckt {count} von {total} Positionen ab \u00B7 {ratio} des Portfolio-Marktwerts",
      coverage_partial_tooltip: "Fairer Wert liegt nur f\u00FCr {count} von {total} Positionen vor. Der Prozentsatz bezieht sich auf den Anteil am MARKTWERT des Portfolios, den diese Positionen ausmachen \u2014 nicht auf den Anteil nach Anzahl der Positionen.",
      coverage_vs_covered_value: "vs abgedeckte Positionen",
    },
    chart: {
      title: "Portfolio-Verlauf",
      subtitle: "Wert vs geschätzter Fair Value",
      portfolio_value: "Portfolio-Wert",
      estimated_fair_value: "Geschätzter Fair Value",
      sp500_series: "S&P 500 Benchmark (Index)",
      sp500_disclaimer: "Der S&P 500 ist ein Kursindex und enthält keine reinvestierten Dividenden.",
      // Phase 8.E.3 — neue KPI- / Methoden- / Datenqualitäts-Copy
      kpi_portfolio_return: "Portfolio-Rendite",
      kpi_benchmark_return: "S&P 500 Rendite",
      kpi_relative_performance: "Relative Performance",
      kpi_relative_performance_hint: "Portfolio-Rendite minus S&P-500-Rendite, in Prozentpunkten.",
      kpi_unavailable: "Nicht verfügbar",
      method_twr_daily: "Zeitgewichtete Rendite",
      method_modified_dietz: "Modified-Dietz-Fallback",
      method_none: "Verlauf unzureichend",
      method_tooltip_twr: "Die zeitgewichtete Rendite (TWR) isoliert die Marktperformance und entfernt den Effekt von Käufen und Verkäufen. Höherwertige Methode.",
      method_tooltip_dietz: "Modified Dietz wird als Fallback verwendet, wenn tägliche Portfolio-Snapshots zu spärlich für eine zeitgewichtete Verkettung sind. Die Richtungsgenauigkeit bleibt erhalten.",
      method_tooltip_scope: "Gemessen wird ausschließlich das getrackte investierte Portfolio. Ungenutztes Broker-Cash ist nicht enthalten.",
      data_quality_good: "Gut",
      data_quality_partial: "Teilweise",
      data_quality_insufficient: "Unzureichend",
      fair_value_toggle_show: "Fair Value einblenden",
      fair_value_toggle_hide: "Fair Value ausblenden",
      preview_locked_range: "Im vollständigen Portfolio verfügbar",
      fair_value_axis_label: "Geschätzter Fair Value ($)",
      index_axis_label: "Performance-Index",
      // Phase 8.E.4 visual-review — currency-mode chart labels.
      value_axis_label: "Portfolio- & Fair-Value-Wert ($)",
      value_mode_subtitle: "Portfoliowert-Verlauf",
      value_mode_notice: "Die tägliche Performance-Historie ist derzeit unvollständig, daher wird der Portfoliowert angezeigt. Die Modified-Dietz-Rendite oben fasst die Periodenrendite zusammen.",
      fv_coverage_gap_title: "L\u00FCcken in der Fair-Value-Linie",
      fv_coverage_gap_body: "Die Fair-Value-Linie wird nur \u00FCber Tage gezeichnet, deren abgedeckte Positionen \u00FCbereinstimmen. {n} Deckungs\u00E4nderung(en) erkannt und als L\u00FCcken dargestellt, damit Summen \u00FCber unterschiedliche Positionsmengen nicht verglichen werden.",
      value_mode_benchmark_note: "Der S&P-500-Vergleich wird oben als KPI angezeigt; ein visueller Indexvergleich erfordert eine vollständigere tägliche Historie.",
      method_tooltip_dietz_value_chart: "Die Rendite wird mit Modified Dietz berechnet. Der Chart zeigt den zugrunde liegenden Portfoliowert, weil die tägliche Performance-Historie unvollständig ist.",
      // Phase 8.E.4 visual-review v6 — benchmark role disclaimer.
      benchmark_disclaimer: "Der S&P 500 dient als Benchmark für das Portfolio. Er ist ein Kursindex und enthält keine reinvestierten Dividenden.",
      // Phase 8.E.4 visual-review v8 — plain-language explanation of
      // what the "Performance-Index" scale means.
      index_explanation: "Der Performance-Index dient dem Vergleich von Portfolio und S&P 500 Benchmark. Beide starten im gewählten Zeitraum bei 100. Ein Wert von 143 bedeutet daher einen Zuwachs von +43 % seit dem Start des gewählten Zeitraums.",
      // Degradierte Zustände
      insufficient_history_title: "Deine Portfolio-Historie startet gerade",
      insufficient_history_body: "Stockaily erfasst dein Portfolio täglich. Mit vollständigen Kauf- und Verkaufsdaten und verfügbaren historischen Kursen lassen sich frühere Portfoliowerte rekonstruieren. Andernfalls beginnt der Graph mit den nutzbaren erfassten Bewertungen.",
      reconstructed_title: "Portfoliohistorie aus Transaktionen rekonstruiert",
      reconstructed_body: "Frühere Tageswerte basieren auf deinen datierten Käufen und Verkäufen und historischen Schlusskursen. Die Rendite berücksichtigt Käufe und Verkäufe. Historischer Fair Value erscheint nur für bereits von Stockaily erfasste Analysen und wird nicht rückwirkend erzeugt.",
      reconstruction_dates_hint: "Für eine frühere Historie bestätige fehlende Kaufdaten im Positionsmenü → Transaktionen anzeigen → Kaufdatum ergänzen. Trage nur das tatsächliche Datum ein; lasse es bei unbekanntem Datum leer.",
      history_building_label: "Historie im Aufbau",
      hide_notice: "Ausblenden",
      show_notices: "Hinweise anzeigen ({n})",
      hide_history_notice: "Hinweis zur Portfolio-Historie ausblenden",
      hide_data_notices: "Hinweise zu Portfolio-Daten ausblenden",
      history_building_title: "Deine Portfolio-Historie wächst",
      history_progress: "Erfassung seit {date} · {n} Tagesbewertungen in diesem Zeitraum.",
      history_progress_no_date: "{n} Tagesbewertungen in diesem Zeitraum.",
      history_building_body: "Stockaily erfasst dein Portfolio täglich. Frühere Werte lassen sich bei vollständigen Kauf- und Verkaufsdaten und verfügbaren historischen Kursen rekonstruieren. Die Rendite berücksichtigt datierte Käufe und Verkäufe; Verkaufserlöse als Barguthaben gehören nicht zum investierten Portfolio.",
      history_benchmark_body: "Die S&P-500-Vergleichslinie erscheint, sobald für diesen Zeitraum genügend nutzbare tägliche Performance-Daten und Vergleichskurse vorliegen. Bis dahin steht die Vergleichsrendite oben, sofern verfügbar.",
      missing_dates_title: "Fehlende Kaufdaten ergänzen",
      missing_dates_body: "Bei einem Nachkauf fehlt das Datum. Deshalb können wir deine Rendite nicht zuverlässig berechnen. Öffne bei der betroffenen Position das Menü → Transaktionen anzeigen → Kaufdatum ergänzen und bestätige das tatsächliche Kaufdatum.",
      transactions_title: "Transaktionen prüfen",
      transactions_body: "Einige Transaktionen lassen sich deiner Performance-Historie nicht zuverlässig zuordnen. Prüfe die Daten unter Transaktionen anzeigen. Weitere Tagesbewertungen allein lösen diese Einträge nicht auf.",
      updating_title: "Portfoliowerte werden aktualisiert",
      updating_body: "Die Tagesbewertung deiner geänderten Positionen ist noch nicht vollständig verfügbar. Der bisherige Tagesstand wird deshalb nicht angezeigt.",
      // Phase 8.E.3 rev-2 — Baseline-Copy
      baseline_note: "Die Performancemessung beginnt am {date}, dem ersten nutzbaren Portfoliowert in diesem Zeitraum.",
      baseline_setup_excluded_note: "Frühere Snapshots aus der Einrichtungsphase werden bei der Renditeberechnung nicht berücksichtigt.",
      unstable_baseline_title: "Performance-Messung noch nicht verfügbar",
      unstable_baseline_body: "Die Performance-Messung beginnt, sobald Stockaily einen vollständigen und stabilen Portfolio-Snapshot erfasst hat.",
      method_tooltip_baseline_scope: "Die Performance wird ab dem ersten vollständigen Stockaily-Portfolio-Snapshot gemessen. Aufgrund der derzeit begrenzten täglichen Historie wird Modified Dietz verwendet.",
      benchmark_unavailable_notice: "Benchmark-Daten sind vorübergehend nicht verfügbar.",
      fair_value_unavailable_notice: "Fair-Value-Verlauf ist für diesen Zeitraum noch nicht verfügbar.",
      partial_data_notice: "An einigen Tagen fehlen vollständige Daten. Angezeigte Ergebnisse sind richtungsweisend.",
      // Tooltip-Labels
      tt_date: "Datum",
      tt_portfolio_index: "Portfolio-Index",
      tt_portfolio_return_since_start: "Portfolio seit {range}-Beginn",
      tt_portfolio_value: "Portfolio-Wert",
      tt_sp500_index: "S&P-500-Index",
      tt_sp500_return_since_start: "S&P 500 seit {range}-Beginn",
      tt_sp500_price: "S&P-500-Kurs",
      tt_relative_performance: "Relative Performance",
      tt_fair_value: "Gesch. Fair Value",
      tt_fair_value_partial: "Teilweise Abdeckung",
      fv_analysis_as_of: "Älteste enthaltene Analyse: {date}",
      fv_analysis_date_unknown: "Analysedatum nicht verfügbar",
      fv_carried_forward: "Fortgeschrieben",
      fv_carried_forward_notice: "Einige Fair-Value-Schätzungen stammen aus früheren Analysen. Am Datenpunkt siehst du das Analysedatum; Marktpreise werden separat erfasst.",
      tt_cash_flow_buy: "KAUF",
      tt_cash_flow_sell: "VERKAUF",
      // Legacy-Keys (Rückwärtskompatibilität)
      sp500_coming_soon: "S&P 500 Benchmark — kommt bald",
      empty_title: "Hier erscheint dein Portfolio-Verlauf",
      empty_body: "Dein Portfolioverlauf erscheint hier nach dem ersten Snapshot.",
      one_snapshot_title: "Das Portfolio-Tracking wurde gestartet",
      one_snapshot_body: "Mit der Zeit erscheint mehr Verlauf.",
      fair_value_start_note: "Das Tracking des geschätzten Fair Values begann am {date}. Frühere aufgezeichnete Werte sind nicht verfügbar.",
      legend_portfolio_value_tip: "Der Portfoliowert ist der aktuelle Marktwert aller offenen Positionen.",
      legend_fair_value_tip: "Der geschätzte Fair Value ergibt sich aus Stückzahl × aktuelle Stockaily-Fair-Value-Schätzung jeder Position.",
      not_enough_history: "Portfolio Growth benötigt mindestens zwei gültige Tages-Snapshots. Deine aktuellen Positionen und Bewertungsdaten sind verfügbar — der Performanceverlauf erscheint, sobald ein weiterer gültiger Snapshot vorliegt.",
      history_days_note: "Es sind erst {days} Tag{plural} aufgezeichneter Portfolioverlauf verfügbar.",
      interpretation_upside: "Mögliches Bewertungs-Upside",
      interpretation_near_fv: "Nahe geschätztem Fair Value",
      interpretation_risk: "Erhöhtes Bewertungsrisiko",
      fv_interpretation_note: "Der geschätzte Fair Value ist eine modellbasierte Schätzung und kein Verkaufssignal. Er zeigt, wo Bewertungsrisiken oder mögliche Chancen konzentriert sind.",
    },
    freshness: {
      cached: "Zwischengespeichert",
      updated_at: "Aktualisiert: {date}",
      up_to_date: "Aktuell",
      stale_title: "Das Portfolio wurde seit dieser Analyse verändert",
      stale_body: "Aktualisiere die Analyse, um die neuesten Positionen zu berücksichtigen.",
      // Phase 8.PH — 4-Status-Etiketten für die KI-Portfolioanalyse.
      status_up_to_date: "Aktuell",
      status_data_temporarily_stale: "Daten vorübergehend veraltet",
      status_market_data_unavailable: "Marktdaten nicht verfügbar",
      status_portfolio_changed_refresh_analysis: "Portfolio geändert — Analyse aktualisieren",
      // Phase 8.B QA-7 — Lokal-Hinweis. Wir zeigen ihn an, wenn die
      // zwischengespeicherte Analyse in einer anderen Sprache erstellt
      // wurde als die aktuelle Oberfläche. Es wird keine automatische
      // Aktualisierung ausgelöst — der Nutzer muss „Portfolioanalyse
      // aktualisieren" selbst klicken.
      locale_mismatch_en: "Diese Analyse wurde auf Englisch erstellt. Aktualisiere die Portfolioanalyse, um eine deutsche Version zu erstellen.",
      locale_mismatch_de: "Diese Analyse wurde auf Deutsch erstellt. Aktualisiere die Portfolioanalyse, um eine englische Version zu erstellen.",
    },
    badge: {
      // Phase 8.B QA-7 — Portfolio Intelligence Badges. Folgt der
      // aktuell aktiven Oberflächensprache, nicht der Sprache des
      // zwischengespeicherten Reviews.
      intelligence: "Portfolio Intelligence · KI",
      intelligence_ai_assisted: "Portfolio Intelligence · KI-gestützt",
      intelligence_deterministic: "Portfolio Intelligence · Deterministisch",
    },
    concentration_band: {
      low: "Geringe Konzentration",
      moderate: "Moderate Konzentration",
      high: "Hohe Konzentration",
    },
    loading: {
      page: "Portfolio wird geladen…",
      holdings: "Positionen werden geladen…",
      prices: "Live-Preise werden aktualisiert…",
      valuation: "Bewertungsdaten werden für {count} Positionen aktualisiert…",
      metrics: "Portfolio-Metriken werden neu berechnet…",
      ai_review: "Dein Portfolio-KI-Review wird erstellt…",
      cached_loaded: "Die letzte zwischengespeicherte Analyse wird verwendet.",
      stale_warning: "Das Portfolio wurde seit dieser Analyse verändert.",
      deterministic_active: "Deterministische Portfolio-Intelligenz aktiv.",
      provider_unavailable: "KI-Anbieter vorübergehend nicht verfügbar. Deterministische Analyse wird angezeigt.",
      cooldown_active: "Aktualisierung verfügbar in {minutes}m.",
      daily_limit: "Tägliches KI-Refresh-Limit erreicht. Morgen erneut versuchen.",
      partial_data: "Eine Position wird noch analysiert.",
    },
    // Phase 8.B QA-7 — Rotierende Loader-Texte während die KI-Analyse
    // erstellt wird. Bewusst neutral formuliert, keine
    // Investoren-Namen.
    loader: {
      running_value_lens: "Wir analysieren deine Positionen nach Bewertungskriterien…",
      buffett_lens: "Wir analysieren deine Positionen mit der Buffett-Linse…",
      scanning_value_traps: "Wir suchen nach möglichen Bewertungsfallen…",
      checking_carriers: "Wir prüfen, welche Positionen das Portfolio tragen…",
      stress_testing: "Wir testen die Schwachstellen des Portfolios…",
      price_vs_value: "Wir prüfen, ob Preis und Wert noch übereinstimmen…",
      separating_signal: "Wir trennen Signal vom Marktrauschen…",
    },
    completeness: {
      partial_warning: "Fair-Value-Abdeckung: {pct}% des Portfolio-Wertes. {excluded} Position(en) noch nicht analysiert.",
      state_refresh_in_progress: "KI-Aktualisierung l\u00E4uft",
      state_analysis_missing: "Analyse ausstehend",
      state_data_unavailable: "Fairer Wert nicht verf\u00FCgbar",
      coverage_summary: "Fair-Value-Abdeckung: {pct}% des Portfolio-Wertes",
      clause_detail: "{holdings} betroffen",
      partial_detail: "{holdings} ohne Fairen Wert \u00B7 abgedeckt: {pct}% des Portfolio-Wertes",
      holdings_singular: "1 Position",
      holdings_plural: "{count} Positionen",
      missing_data: "Daten nicht verfügbar",
    },
    diagnostics: {
      title: "Portfolio-Diagnose",
      subtitle: "Admin-Ansicht zur Portfolio-Gesundheit eines Nutzers.",
      user_id_label: "Nutzer-ID",
      load_btn: "Diagnose laden",
      action_clear_cache: "KI-Review-Cache löschen",
      action_rebuild_snapshot: "Heutigen Snapshot neu erstellen",
      action_recalc_metrics: "Deterministische Metriken neu berechnen",
      confirm_clear_cache: "Zwischengespeichertes KI-Review für diesen Nutzer löschen?",
      confirm_rebuild_snapshot: "Heutigen Snapshot für diesen Nutzer neu erstellen?",
      confirm_recalc_metrics: "Deterministische Metriken für diesen Nutzer neu berechnen?",
      action_ok: "Erledigt.",
      action_failed: "Aktion fehlgeschlagen.",
      not_found: "Keine Portfolio-Daten für diesen Nutzer.",
    },
    refresh: {
      prices: "Preise aktualisieren",
      analysis: "Portfolio-Analyse aktualisieren",
      next_in_minutes: "Verfügbar in {n}m",
      refreshes_left: "Refreshes heute übrig",
      last_analysis: "Letzte Analyse",
      tooltip_no_holdings: "Füge zuerst eine Position hinzu.",
      // Phase 8.B QA-9 — Tageslimit hat Vorrang vor dem Cooldown.
      // Sobald `refreshes_left_today === 0` wird der Cooldown-Timer
      // ausgeblendet und stattdessen die Reset-Information angezeigt.
      available_tomorrow: "Morgen wieder verfügbar",
      available_tomorrow_at: "Morgen ab {time} wieder verfügbar",
      tooltip_daily_limit_reached: "Tägliches Limit für Portfolio-KI-Aktualisierungen erreicht.",
    },
    kpi_extra: {
      unrealized_pl_hint_pending: "Wartet auf Live-Preise",
    },
    help: {
      title: "So funktioniert das Portfolio-Scoring",
      subtitle: "Stockaily nutzt dieselbe Bewertungslogik wie bei jeder Aktienanalyse für die Portfolio-Sicht.",
      row_value_k: "Portfolio-Wert",
      row_value_v: "Summe aus Anteilen × aktuellem Preis über alle Positionen. Wird nur angezeigt, wenn aktuelle Preise verfügbar sind.",
      row_fv_k: "Geschätzter Fair Value",
      row_fv_v: "Summe aus Anteilen × Stockaily Fair Value pro Aktie. Basiert auf derselben Bewertungslogik, die für einzelne Aktienanalysen verwendet wird.",
      row_upside_k: "Upside / Downside",
      row_upside_v: "Zeigt, wie weit der geschätzte Fair Value über oder unter deinem aktuellen Portfolio-Wert liegt.",
      row_score_k: "Gewichteter Opportunity Score",
      row_score_v: "Der AI Opportunity Score jeder Position, gewichtet nach ihrem Anteil am Portfolio. Höher bedeutet mehr Chance gegenüber dem Fair Value.",
      row_risk_k: "Risiko",
      row_risk_v: "Das Risiko jeder Position, gewichtet über das gesamte Portfolio.",
      disclaimer: "Stockaily ist ein Bildungs-Bewertungstool. Keine Anlageberatung.",
      close: "Verstanden",
    },
    actions: {
      add_holding: "Position hinzufügen",
      retry: "Erneut versuchen",
    },
    export: {
      menu_label: "Exportieren",
      aria_label: "Portfolio exportieren",
      title_hint: "PDF / CSV exportieren",
      pdf_label: "PDF-Bericht exportieren",
      pdf_hint: "Portfolio-Intelligence-Bericht mit Stockaily-Branding",
      csv_label: "CSV exportieren (Positionen)",
      csv_hint: "Maschinenlesbarer Positionsauszug",
      pdf_success: "PDF-Bericht bereit.",
      csv_success: "CSV-Export bereit.",
      failed: "Export fehlgeschlagen. Bitte erneut versuchen.",
      premium_required: "Portfolio-Export ist eine Premium-Funktion.",
    },
    insights: {
      top_opportunity: "Beste Chance",
      top_opportunity_hint: "Position mit dem größten Upside ggü. Fair Value.",
      largest_risk: "Größtes Bewertungsrisiko",
      largest_risk_hint: "Position am weitesten über dem Fair Value.",
      highest_weight: "Höchste Gewichtung",
      highest_weight_hint: "Position mit dem größten Portfolio-Anteil.",
      biggest_winner: "Größter Gewinner",
      biggest_winner_hint: "Stärkste unrealisierte Rendite.",
      biggest_loser: "Größter Verlierer",
      biggest_loser_hint: "Größter unrealisierter Verlust.",
      concentration: "Konzentration",
      concentration_high: "Eine Position trägt einen erheblichen Portfolio-Anteil.",
      concentration_normal: "Die Gewichtung wirkt insgesamt ausgeglichen.",
    },
    table: {
      ticker: "Ticker",
      company: "Unternehmen",
      shares: "Anteile",
      buy_price: "Einstand",
      current_price: "Aktuell",
      market_value: "Marktwert",
      pnl: "G/V",
      weight: "Gewichtung",
      fair_value: "Fair Value",
      upside: "Upside",
      ai_score: "KI-Score",
      risk: "Risiko",
      actions: "Aktionen",
      edit: "Bearbeiten",
      delete: "Löschen",
    },
    dialog: {
      title_add: "Position hinzufügen",
      title_edit: "Position bearbeiten",
      title_add_purchase: "Zur bestehenden Position hinzufügen",
      description: "Füge eine Position hinzu, um ihren Wert gegenüber dem Stockaily Fair Value zu tracken.",
      description_add_purchase: "Erfasse einen weiteren Kauf für {ticker}. Dein durchschnittlicher Einstandspreis wird automatisch aktualisiert.",
      ticker: "Ticker",
      ticker_placeholder: "Ticker oder Unternehmen suchen (AAPL, Microsoft, Nvidia…)",
      hint_select_stock: "Wähle eine Aktie aus der Liste, um fortzufahren.",
      err_select_stock: "Bitte wähle eine Aktie aus den Vorschlägen.",
      shares: "Anteile",
      shares_new: "Neue Anteile",
      buy_price: "Einstandspreis",
      buy_price_new: "Kaufpreis pro Anteil",
      buy_date: "Kaufdatum",
      buy_date_tooltip: "Beim Anfangsbestand optional; bei einem Nachkauf erforderlich, damit die Rendite den Geldfluss berücksichtigen kann. Ein Datum allein ergänzt noch keine historischen Kurse.",
      required: "erforderlich",
      purchase_date_required_hint: "Trage das tatsächliche Kaufdatum ein, damit deine Rendite diesen Kauf berücksichtigen kann. Bei Nachkäufen ist das Datum erforderlich.",
      err_buy_date_required: "Trage das tatsächliche Kaufdatum dieses Nachkaufs ein.",
      err_buy_date: "Trage ein gültiges Kaufdatum bis einschließlich heute (UTC) ein.",
      buy_date_tooltip_label: "Warum das Kaufdatum angeben?",
      notes: "Notizen",
      fees: "Gebühren",
      optional: "optional",
      add: "Hinzufügen",
      add_purchase: "Kauf hinzufügen",
      save: "Speichern",
      saving: "Speichere…",
      cancel: "Abbrechen",
      err_ticker: "Bitte einen Ticker eingeben.",
      err_shares: "Anteile müssen größer als 0 sein.",
      err_buy_price: "Einstandspreis muss größer als 0 sein.",
      existing_position: "Bestehende Position",
      existing_shares: "Aktuelle Anteile",
      existing_avg_buy: "Aktueller Ø Einstandspreis",
      projected_section: "Nach diesem Kauf",
      projected_shares: "Anteile gesamt",
      projected_avg_buy: "Neuer Ø Einstandspreis",
    },
    delete: {
      title: "Position löschen?",
      body: "{ticker} wird aus deinem Portfolio entfernt. Lösche diese Position nur, wenn sie versehentlich hinzugefügt wurde. Verwende für einen tatsächlichen Verkauf die Funktion Verkauf erfassen.",
      body_with_history: "{ticker} hat {count} Transaktion(en) im Verlauf. Eine Löschung erzeugt keinen realisierten G/V. Lösche diese Position nur, wenn sie versehentlich hinzugefügt wurde. Verwende für einen tatsächlichen Verkauf die Funktion Verkauf erfassen.",
      confirm: "Löschen",
      cancel: "Abbrechen",
    },
    locked: {
      title: "Portfolio Intelligence ist ein Premium-Feature",
      body: "Schalte Portfolio-Tracking, Fair-Value-Vergleiche und KI-Bewertung deiner Positionen frei.",
      cta: "Auf Premium upgraden",
      footnote: "Inkl. Portfolio KI-Review, Fair-Value-Tracking und Wachstums-Dashboard.",
      demo: {
        badge: "Portfolio-Vorschau",
        badge_hint: "Beispieldaten. Nicht mit einem echten Konto verkn\u00FCpft.",
        kpi_largest_risk: "Gr\u00F6\u00DFtes Bewertungsrisiko",
        kpi_largest_risk_value: "1 Position \u00FCber Fair Value",
        kpi_1y_growth: "1J Portfolio-Wachstum",
        kpi_risk_medium: "Mittel",
        chart_kicker: "Beispiel-Portfolio-Ansicht",
        chart_title: "Portfolio-Wachstum",
        chart_a11y: "Illustratives Portfolio-Wachstums-Diagramm",
        chart_disclosure: "Illustrative Portfoliodaten f\u00FCr Produktvorschau-Zwecke.",
        legend_portfolio: "Portfolio",
        legend_fair_value: "Gesch\u00E4tzter Fair Value",
        legend_sp500: "S&P 500",
        mod_sector_label: "Sektor-Konzentration",
        mod_sector_title: "Technologie \u00B7 42%",
        mod_sector_sub: "Beispiel-Sektor-Mix",
        mod_risk_label: "Gr\u00F6\u00DFtes Bewertungsrisiko",
        mod_risk_title: "1 Position notiert 16% \u00FCber dem gesch\u00E4tzten Fair Value",
        mod_risk_sub: "",
        mod_opp_label: "St\u00E4rkste Opportunit\u00E4t",
        mod_opp_title: "Beispiel-Position \u00B7 18% gesch\u00E4tztes Upside",
        mod_opp_sub: "",
        mod_ai_label: "Portfolio KI-Review",
        mod_ai_body: "Dein Portfolio zeigt starke Gesch\u00E4ftsqualit\u00E4t, w\u00E4hrend das Bewertungsrisiko in zwei Positionen konzentriert bleibt. Erw\u00E4ge die Konzentration und die Position mit der geringsten \u00DCberzeugung zu \u00FCberpr\u00FCfen.",
        mod_ai_footer: "Beispiel-Review \u00B7 Vollst\u00E4ndiger Review ist Premium",
      },
    },
    loggedout: {
      title: "Verstehe dein gesamtes Portfolio mit Stockaily.",
      body: "Verfolge Performance, Fair Value, Opportunit\u00E4t und Risiko \u00FCber jede Position.",
      signup_cta: "Kostenloses Konto erstellen",
      login_cta: "Anmelden",
      footnote: "Kostenloses Konto. Keine Karte erforderlich.",
      view_premium_link: "Premium-Funktionen ansehen",
    },
    upsell: {
      title: "Portfolio Intelligence freischalten",
      body: "Sieh Bewertung, Performance und Risiko \u00FCber dein gesamtes Portfolio.",
      cta: "Premium entdecken",
      footnote: "Du siehst Funktionen und Preise vor dem Checkout. In diesem Schritt entstehen keine Kosten.",
    },
    empty: {
      title: "Baue deine Portfolio-Intelligenz auf",
      body: "Füge deine erste Position hinzu, um Performance, Fair Value, Opportunity Score und Risiko an einem Ort zu verfolgen.",
      cta: "Position hinzufügen",
      learn_more: "So funktioniert das Scoring",
      feature_fair_value: "Fair Value über alle Positionen verfolgen",
      feature_upside: "Upside und Downside auf Portfolio-Ebene sehen",
      feature_risk: "Risiko und Chance je Position bewerten",
    },
    // Phase 8.C-3 — Sonderzustand, wenn alle offenen Positionen verkauft
    // wurden, aber noch eine Historie geschlossener Positionen vorhanden ist.
    no_open_with_history: {
      heading: "Keine offenen Positionen",
      subtext: "Füge eine neue Position hinzu, um einen neuen Portfolio-Lebenszyklus zu starten.",
    },
    // Phase 8.C-3 follow-up — Backfill für ältere Eröffnungstransaktionen
    // (nur für Owner/Admin sichtbar; keine Anzeige für normale Nutzer).
    backfill_legacy: {
      heading: "Alte Eröffnungstransaktionen nachtragen",
      description: "Einmaliger, idempotenter Backfill, der für jede berechtigte ältere offene Position ohne Transaktionshistorie genau eine synthetische Eröffnungs-BUY-Transaktion erstellt. Aggregate (Anzahl, Durchschnittskaufpreis, Einstandswert) werden niemals geändert.",
      run_dry_run: "Probelauf starten",
      apply: "Backfill anwenden",
      reset: "Zurücksetzen",
      eligible: "Berechtigte Lebenszyklen",
      skipped: "Übersprungene Lebenszyklen",
      no_eligible: "Keine berechtigten Lebenszyklen — nichts zu übernehmen.",
      eligible_count: "Berechtigt: {count}",
      skipped_count: "Übersprungen: {count}",
      confirm_label: "Mir ist bewusst, dass synthetische Eröffnungs-BUY-Transaktionen für berechtigte ältere Positionen erstellt werden.",
      column_ticker: "Ticker",
      column_shares: "Anzahl",
      column_avg_price: "Ø Kaufpreis",
      column_cost_basis: "Synth. Einstand",
      column_reconcile: "Abgleich-Diff.",
      column_purchase_date: "Kaufdatum",
      column_date_status: "Datumsstatus",
      column_reason: "Skip-Grund",
      created_heading: "Erstellte Transaktionen",
      created_count: "{count} synthetische BUY-Transaktion(en) erstellt",
      affected_tickers: "Betroffene Ticker",
      dry_run_first: "Bitte zuerst einen Probelauf ausführen.",
      production_warning: "Vor dem Anwenden Umgebung und user_id prüfen.",
    },
    // Phase 8.D — Tägliche Portfolio-Snapshots (Admin-Panel).
    daily_snapshots: {
      heading: "Tägliche Portfolio-Snapshots",
      description: "Hintergrund-Snapshot-Job für Premium-Portfolios. Ein kanonischer Eintrag pro Nutzer pro UTC-Tag. Keine LLM-Aufrufe.",
      scheduler: "Scheduler",
      enabled: "Aktiv",
      disabled: "Deaktiviert",
      registered: "Registriert",
      not_registered: "Nicht registriert",
      cron: "Cron",
      env: "Umgebung",
      lock: "Job-Lock",
      lock_free: "Frei",
      lock_held: "Gehalten von {holder} seit {since}",
      eligible: "Berechtigte Premium-Nutzer",
      last_run: "Letzter Job-Lauf",
      run_dry_run: "Probelauf starten",
      run_now: "Snapshot-Job jetzt starten",
      retry_failed: "Fehlgeschlagene Nutzer erneut versuchen",
      view_last: "Letzten Job anzeigen",
      confirm_run_now: "Mir ist bewusst, dass ein täglicher Snapshot-Job ausgeführt wird und Snapshots geschrieben werden.",
      confirm_retry: "Mir ist bewusst, dass fehlgeschlagene Nutzer aus der ausgewählten job_run_id erneut verarbeitet werden.",
      col_user: "Nutzer",
      col_status: "Status",
      col_reason: "Grund",
      col_open_holdings: "Offene Positionen",
      col_missing: "Fehlende Ticker",
      // Phase 8.D — Sichtbarkeits-Fix: Spalten der Nutzer-Ergebnis-Tabelle.
      col_persisted: "Gespeichert",
      col_coverage: "Abdeckung",
      col_partial_reason: "Grund (partial)",
      col_stale: "Veraltete Ticker",
      persisted_yes: "Ja",
      persisted_no: "Nein",
      dim_price: "Preis",
      dim_fair_value: "Fair Value",
      dim_score: "KI-Score",
      dim_risk: "Risiko",
      no_eligible: "Keine berechtigten Nutzer gefunden.",
      job_status_complete: "vollständig",
      job_status_partial: "teilweise",
      job_status_failed: "fehlgeschlagen",
      // Phase 8.D — zusätzliche Admin-UI-Texte (Owner Console).
      refresh_status: "Status aktualisieren",
      production_warning: "Dadurch werden die heutigen kanonischen Portfolio-Snapshots f\u00fcr alle berechtigten Premium-Nutzer im ausgew\u00e4hlten Umfang erstellt oder aktualisiert. Der Vorgang ist pro Nutzer und UTC-Tag idempotent, schreibt jedoch echte Snapshot-Daten.",
      force_refresh_prices: "Preise zwangsweise aktualisieren",
      force_refresh_prices_hint: "Vorübergehend nicht verfügbar; diese Option wurde deaktiviert, weil sie bisher den Snapshot-Schreibschutz umgangen hat.",
      batch_limit_label: "Batch-Limit (optional)",
      batch_limit_placeholder: "z. B. 50",
      batch_limit_invalid: "Batch-Limit muss eine positive Ganzzahl sein.",
      user_scope_label: "Ziel-Nutzer (optional)",
      user_scope_all: "Alle berechtigten Premium-Nutzer",
      user_scope_selected: "Begrenzt auf user_id: {user_id}",
      retry_target_label: "Retry job_run_id",
      retry_target_placeholder: "F\u00fcr Retry eine vorherige job_run_id einf\u00fcgen",
      retry_target_autofilled: "Automatisch aus letztem {status}-Lauf \u00fcbernommen",
      retry_no_failed: "Kein fehlgeschlagener oder teilweiser Lauf zum erneuten Versuch verf\u00fcgbar.",
      retry_target_required: "Eine job_run_id ist f\u00fcr den Retry erforderlich.",
      snapshot_date_label: "Aktuelles UTC-Snapshot-Datum",
      eligible_count_estimate: "Gesch\u00e4tzte berechtigte Nutzer",
      preview_users_heading: "Vorschau (erste {count} Nutzer)",
      results_heading: "Ergebnisse pro Nutzer",
      no_last_run: "Bisher kein Job-Lauf erfasst.",
      dedup_ratio: "Dedup-Quote",
      api_calls: "API-Aufrufe",
      cache_hits: "Cache-Treffer",
      duration: "Dauer",
      seconds: "s",
      reset: "Bericht zur\u00fccksetzen",
      job_run_id_label: "job_run_id",
      started_at: "Gestartet am",
      finished_at: "Beendet am",
      status_label: "Status",
      success_count: "Erfolgreich",
      partial_count: "Teilweise",
      failed_count: "Fehlgeschlagen",
      unique_tickers_label: "Eindeutige Ticker",
      lock_status_free: "Lock frei \u2014 Ausf\u00fchrung m\u00f6glich.",
      lock_status_held: "Job-Lock derzeit gehalten von {holder} (seit {since}). Vor Ausf\u00fchrung warten oder freigeben.",
      scheduler_disabled_banner: "Der Scheduler ist derzeit deaktiviert (PORTFOLIO_DAILY_SNAPSHOTS_ENABLED=false). Manuelle Ausf\u00fchrungen sind weiterhin verf\u00fcgbar.",
    },
    toast: {
      holding_added: "Position hinzugefügt.",
      holding_merged: "Zur bestehenden {ticker}-Position hinzugefügt.",
      holding_updated: "Position aktualisiert.",
      holding_deleted: "Position entfernt.",
      prices_refreshed: "Preise aktualisiert.",
      analysis_refreshed: "Portfolio-Analyse aktualisiert.",
      sale_partial: "Verkauf erfasst. Die Position bleibt geöffnet.",
      sale_full: "Verkauf erfasst. Die Position wurde geschlossen.",
    },
    action_menu: {
      label: "Aktionen",
      add_purchase: "Kauf hinzufügen",
      record_sale: "Verkauf erfassen",
      view_transactions: "Transaktionen anzeigen",
      edit_metadata: "Positionsdaten bearbeiten",
      delete_incorrect: "Fehlerhafte Position löschen",
    },
    sell: {
      title: "Verkauf erfassen",
      open_status: "Offener Lebenszyklus",
      available_shares: "Verfügbare Anteile",
      avg_buy_price: "Ø Einstandspreis",
      open_cost_basis: "Offene Kostenbasis",
      current_price: "Aktueller Kurs",
      current_unrealized: "Aktueller nicht realisierter G/V",
      field_shares: "Zu verkaufende Anteile",
      field_price: "Verkaufspreis pro Anteil",
      field_date: "Verkaufsdatum",
      field_date_tooltip: "Empfohlen für genaue Haltedauern und eine vollständige Transaktionshistorie.",
      field_date_tooltip_label: "Warum das Verkaufsdatum angeben?",
      field_fees: "Gebühren",
      field_notes: "Notizen (optional)",
      sell_all: "Alle verkaufen",
      preview_title: "Verkaufs-Vorschau",
      preview_caveat: "Nur informativ — die Backend-Berechnung ist verbindlich.",
      preview_gross: "Bruttoerlös",
      preview_fees: "Gebühren",
      preview_net: "Nettoerlös",
      preview_cost_basis_released: "Freigegebene Kostenbasis",
      preview_realized_pl: "Geschätzter realisierter G/V",
      preview_realized_pl_pct: "Geschätzter realisierter G/V %",
      preview_remaining_shares: "Verbleibende Anteile",
      preview_remaining_cost_basis: "Verbleibende Kostenbasis",
      preview_status: "Positionsstatus nach Verkauf",
      status_open: "Offen",
      status_closed: "Nach Verkauf geschlossen",
      submit: "Verkauf erfassen",
      cancel: "Abbrechen",
      submitting: "Verkauf wird erfasst\u2026",
      validation_shares_positive: "Anteile müssen größer als 0 sein.",
      validation_shares_max: "Anteile dürfen die verfügbare Stückzahl nicht überschreiten.",
      validation_price_positive: "Der Verkaufspreis muss größer als 0 sein.",
      validation_fees_nonneg: "Gebühren dürfen nicht negativ sein.",
      validation_date_invalid: "Das Verkaufsdatum ist ungültig.",
      error_conflict: "Die verfügbare Stückzahl hat sich geändert. Prüfe die aktualisierte Position und versuche es erneut.",
      error_insufficient: "Nicht genügend Anteile verfügbar, um diesen Verkauf zu erfassen.",
      error_generic: "Der Verkauf konnte nicht erfasst werden. Bitte versuche es erneut.",
    },
    closed: {
      heading: "Geschlossene Positionen",
      empty: "Geschlossene Positionen erscheinen hier, nachdem du einen vollständigen Verkauf erfasst hast.",
      collapse_show: "Einblenden",
      collapse_hide: "Ausblenden",
      col_ticker: "Ticker",
      col_company: "Unternehmen",
      col_first_buy: "Erstkauf",
      col_final_sale: "Letzter Verkauf",
      col_total_shares: "Verkaufte Anteile",
      col_avg_buy: "Ø Einstandspreis",
      col_avg_sell: "Ø Verkaufspreis",
      col_proceeds: "Erlös gesamt",
      col_cost_basis: "Kostenbasis gesamt",
      col_fees: "Gebühren gesamt",
      col_realized_pl: "Realisierter G/V",
      col_realized_pct: "Realisierter G/V %",
      col_holding_period: "Haltedauer",
      col_transactions: "Transaktionen",
      col_action: "Aktion",
      view_history: "Transaktionen anzeigen",
      holding_period_days: "{days} Tag(e)",
      holding_period_unavailable: "Nicht verfügbar",
      holding_period_unavailable_tooltip: "Das ursprüngliche Kaufdatum ist unvollständig. Eine genaue Haltedauer kann daher nicht berechnet werden.",
      holding_period_unavailable_tooltip_label: "Warum ist die Haltedauer nicht verfügbar?",
    },
    history: {
      title: "{ticker} Transaktionshistorie",
      lifecycle_status_open: "Offener Lebenszyklus",
      lifecycle_status_closed: "Geschlossener Lebenszyklus",
      first_txn: "Erste Transaktion",
      latest_txn: "Letzte Transaktion",
      col_date: "Datum",
      col_type: "Typ",
      col_shares: "Anteile",
      col_price: "Preis / Anteil",
      col_fees: "Gebühren",
      col_gross: "Brutto",
      col_net: "Netto",
      col_realized_pl: "Realisierter G/V",
      col_notes: "Notizen",
      col_source: "Quelle",
      type_buy: "KAUF",
      type_sell: "VERKAUF",
      empty: "Keine Transaktionen vorhanden.",
      error: "Die Transaktionshistorie konnte nicht geladen werden.",
      retry: "Erneut versuchen",
      close: "Schließen",
      date_unavailable: "Datum nicht verfügbar",
      add_purchase_date: "Kaufdatum ergänzen",
      confirm_purchase_date: "Datum bestätigen",
      date_confirmation_hint: "Trage das tatsächliche Kaufdatum ein. Nur das fehlende Datum wird ergänzt; Stückzahl, Preis und Gebühren bleiben gleich. Wenn du das Datum nicht kennst, lasse es offen.",
      date_save_error: "Das Datum konnte nicht gespeichert werden. Lade die Transaktionen neu und versuche es erneut.",
      date_conflict: "Diese Transaktion hat bereits ein Datum. Lade die Transaktionen neu, um den aktuellen Wert zu sehen.",
      source_label: "Quelle",
      source_labels: {
        migrated_legacy_opening_lot: "Ursprünglicher Portfolioeintrag",
        user_opening_lot: "Ursprünglicher Portfolioeintrag",
        user_additional_purchase: "Zusätzlicher Kauf",
        user_sell: "Erfasster Verkauf",
        imported: "Importierte Transaktion",
        unknown: "Erfasste Transaktion",
      },
    },
    pl_card: {
      title: "Gewinn-/Verlust-Aufschlüsselung",
      unrealized: "Nicht realisierter G/V",
      realized: "Realisierter G/V",
      total: "Gesamt-G/V",
      tooltip_unrealized: "Gewinn oder Verlust auf derzeit offenen Positionen, basierend auf den neuesten verfügbaren Preisen.",
      tooltip_realized: "Gewinn oder Verlust aus erfassten VERKAUFS-Transaktionen. Historisch und informativ \u2014 Verkaufserlöse werden nicht innerhalb von Stockaily gehalten.",
      tooltip_total: "Realisierter G/V plus nicht realisierter G/V. Der oben angezeigte Portfoliowert enthält nur offene Positionen.",
    },
    stale_after_sell: "Das Portfolio wurde seit dieser Analyse verändert",
    delete_warning_transactions: "Diese Position hat {count} Transaktion(en). Eine Löschung erzeugt keinen realisierten G/V.",
    delete_warning_use_sale: "Wenn dies einen echten Verkauf darstellt, brich ab und verwende stattdessen Verkauf erfassen.",
    error: {
      load_failed: "Dein Portfolio konnte nicht geladen werden. Bitte versuche es erneut.",
      duplicate_holding: "Diese Position existiert bereits. Bitte bearbeite stattdessen die bestehende.",
      holdings_limit: "Du hast das Phase-1-Limit von 50 Positionen erreicht.",
      premium_required: "Portfolio-Tracking ist ein Premium-Feature.",
      save_failed: "Speichern fehlgeschlagen. Bitte versuche es erneut.",
      delete_failed: "Entfernen fehlgeschlagen. Bitte erneut versuchen.",
      refresh_prices_failed: "Preise konnten gerade nicht aktualisiert werden.",
      refresh_analysis_failed: "Portfolio-Analyse konnte nicht aktualisiert werden.",
      cooldown_prices: "Preisaktualisierung hat eine Wartezeit. Bitte kurz später erneut versuchen.",
      cooldown_analysis: "Analyse-Aktualisierung hat eine Wartezeit. Bitte später erneut versuchen.",
      daily_limit: "Tageslimit für die KI-Analyse erreicht. Dein Portfolio behält die letzte Analyse.",
      hard_limit: "Tageskontingent erreicht. Aktualisierungen gehen morgen weiter.",
      job_running: "Eine Analyse läuft bereits.",
    },
  },

  // ----------------------------------------------------------------
  // Consent Foundation & Cookie Banner (2026-08-02) — deutsche Fassung
  // ----------------------------------------------------------------
  consent: {
    banner: {
      title: "Deine Datenschutz-Auswahl",
      body:
        "Stockaily nutzt nur notwendige Speicherung, um die Seite sicher zu halten, deine Sprache zu merken und deine Einwilligungsentscheidung zu speichern. Die optionale Analyse (PostHog) ist nicht aktiv und läuft nicht, solange du nicht aktiv zustimmst. Du kannst deine Auswahl jederzeit über \u201ECookie-Einstellungen\u201C im Footer ändern.",
      link_cookies: "Cookie-Richtlinie",
      link_privacy: "Datenschutzerklärung",
      accept_all: "Alle akzeptieren",
      necessary_only: "Nur notwendige",
      settings: "Einstellungen",
      close_label: "Cookie-Banner schließen",
    },
    dialog: {
      title: "Cookie-Einstellungen",
      subtitle:
        "Du entscheidest, welche optionalen Kategorien Stockaily aktivieren darf. Notwendige Speicherung ist immer aktiv, weil die Seite ohne sie nicht funktioniert.",
      category_necessary_title: "Notwendig",
      category_necessary_body:
        "Einwilligungsspeicherung, Anmelde-Session, Sprachvoreinstellung und weitere Speicherung, die für die Bereitstellung der Website und der Kernfunktionen erforderlich ist. Immer aktiv \u2013 diese Kategorie lässt sich nicht deaktivieren.",
      category_necessary_locked: "Immer aktiv",
      category_analytics_title: "Analyse",
      category_analytics_body:
        "Produkt-Analyse via PostHog (EU-Cloud, Region Paris/Frankfurt). Wird nur geladen und sendet nur Ereignisse, nachdem du hier zustimmst. IP-Adressen werden verworfen, Autocapture und Session Replay sind deaktiviert, und es werden ausschließlich anonyme Produkt-Ereignisse aus einer festen Liste gesendet \u2013 keine Namen, keine E-Mail-Adressen, keine Tickersymbole, keine Portfolio-Inhalte, keine Finanzwerte.",
      save: "Auswahl speichern",
      accept_all: "Alle akzeptieren",
      necessary_only: "Nur notwendige",
      cancel: "Abbrechen",
      current_state: "Deine gespeicherte Auswahl",
      state_none: "Noch keine Entscheidung gespeichert",
      state_all: "Optionale Analyse: an",
      state_necessary_only: "Optionale Analyse: aus",
      updated_at: "Zuletzt aktualisiert",
    },
    footer_settings_button: "Cookie-Einstellungen",
  },
  research_transparency: {
    // WS-1 kompakter / langer Produkt-Disclaimer — deutsche Übersetzung
    // des kanonischen englischen Textes (siehe `ws1RegCopy.js`). Wird
    // von der Disclaimer-Komponente über die i18n-Route bezogen, wenn
    // eine sprachgebundene Seite die Sprache erzwingt, ohne die
    // persistierte App-Sprache zu ändern.
    disclaimer_compact:
      "Modellbasiertes Research, keine personalisierte Beratung. Investieren ist mit Risiken verbunden.",
    disclaimer_long:
      "Stockaily bietet modellbasiertes Finanz-Research und -Informationen. Es handelt sich nicht um personalisierte Anlageberatung und berücksichtigt keine individuellen Umstände. Schätzungen können falsch sein. Investieren ist mit Risiken verbunden und Sie treffen Ihre Entscheidungen selbst.",
    methodology_long_v1:
      "Gewichtetes Fair-Value-Modell aus DCF, Sektor-KGV und fundamentalen Faktoren (Methodik v1)",
    methodology_short_v1: "Kombiniertes DCF-, Sektor-KGV- und Fundamentaldatenmodell (v1)",
    methodology_missing: "Methodik-Metadaten nicht verfügbar",
    conflicts_no_compensation:
      "Stockaily erhält keine Vergütung vom analysierten Unternehmen.",
    corrections_none: "Keine Korrekturen veröffentlicht.",
    corrections_as_of_prefix: "Stand",
    methodology_label: "Methodik",
    conflicts_label: "Interessenkonflikte",
    corrections_label: "Korrekturen",
    technical_details: "Technische Details",
    tech_schema: "Schema",
    tech_regcopy: "Regulatorischer Text",
    tech_content: "Inhaltstyp",
    tech_provider: "Anbieter",
    tech_model: "Modell-Identifikator",
    // Korrektur-Status/Grund-Codes — kanonisch aus dem Backend
    // (`CorrectionStatus`). Wird bevorzugt gegenüber dem englischen
    // Backend-Label verwendet, damit ein deutscher UI-Kontext keinen
    // hartkodierten englischen Text zeigt.
    correction_status_metadata_corrected: "Metadaten aktualisiert",
    correction_status_data_corrected: "Zugrundeliegende Daten korrigiert",
    correction_status_methodology_updated: "Methodik aktualisiert",
    correction_status_material_research_updated: "Research aktualisiert",
    correction_status_superseded: "Durch neuere Analyse ersetzt",
    correction_status_withdrawn: "Zurückgezogen",
    correction_status_unknown: "Korrektur veröffentlicht",
    // Slice C — Zentrale Seite „Research-Transparenz".
    page_title: "Research-Transparenz",
    page_intro:
      "Wie Stockaily den Fair Value und den AI Opportunity Score berechnet, was unsere KI leistet und was nicht, und welche Daten wir verwenden.",
    ai_assisted_explanation: "KI-gestützte Erklärung auf Basis der Stockaily-Modellergebnisse",
    // Überschriften
    section_what_we_provide: "Was Stockaily bereitstellt",
    section_fair_value: "Wie der Fair Value berechnet wird",
    section_ai_score: "Wie der AI Opportunity Score berechnet wird",
    section_role_of_ai: "Was KI leistet — und was nicht",
    section_data_sources: "Datenquellen, Zeitstempel und Datenqualität",
    section_assumptions: "Annahmen, Unsicherheit und fehlende Daten",
    section_conflicts: "Interessenkonflikte",
    section_corrections: "Korrekturen",
    section_limitations: "Wichtige Einschränkungen",
    section_tech_details: "Technische Details",
    // Was wir bereitstellen
    what_body:
      "Stockaily ist Research-, Analyse- und Informationssoftware. Sie erzeugt modellbasierte Schätzungen des Fair Value, einen numerischen AI Opportunity Score und begleitende Erläuterungen. Sie stellt keine personalisierte Anlageberatung, keine individualisierten Kauf-/Verkauf-/Halte-Anweisungen und keine Empfehlungen zur Positionsgröße bereit und sichert weder Genauigkeit, Wertentwicklung, Erträge noch Ergebnisse zu.",
    // Fair Value
    fv_intro:
      "Der angezeigte Fair Value ist eine gewichtete Kombination aus einem vereinfachten Discounted-Cash-Flow-Modell (DCF), einem sektorrelativen KGV-Anker und qualitätsadjustierten Fundamentalfaktoren. Er wird deterministisch berechnet, bevor eine KI-Erläuterung erzeugt wird.",
    fv_weights_title: "Basisgewichte der Komponenten",
    fv_weight_dcf: "Vereinfachter DCF",
    fv_weight_pe: "Sektorrelativer KGV-Anker",
    fv_weight_fcf: "Cashflow-Qualitätsfaktor",
    fv_weight_profitability: "Profitabilitätsfaktor",
    fv_weight_rev_growth: "Umsatzwachstumsfaktor",
    fv_weight_eps_growth: "Gewinnwachstumsfaktor",
    fv_weight_bs: "Bilanzfaktor",
    fv_weights_note:
      "Dies sind Basisgewichte, keine festen Gewichte für jede Analyse.",
    fv_fallbacks_title: "Umgang mit unvollständigen Daten",
    fv_fallback_dcf:
      "Wenn der DCF wegen ungültiger oder fehlender Cashflow-Eingaben nicht berechenbar ist, wird sein Basisgewicht der Relative-Bewertungs-Komponente zugewiesen.",
    fv_fallback_missing:
      "Weitere nicht verfügbare Komponenten werden ausgelassen und die verbleibenden Gewichte normalisiert.",
    fv_fallback_extreme:
      "Ist keine Bewertungskomponente verfügbar, verwendet ein Extremfallback den aktuellen Marktpreis, damit die Anzeige nicht stillschweigend versagt.",
    fv_range_title: "Fair-Value-Spanne",
    fv_range_body:
      "Die Fair-Value-Spanne wird aus dem zentralen Fair Value über eine modusabhängige Unsicherheitsbandbreite abgeleitet. Geringere Datenvollständigkeit kann diese Bandbreite erweitern. Die Spanne ist kein Wahrscheinlichkeitsintervall und kein zugesicherter Zielwert.",
    fv_sector_ref_title: "Sektor-Referenzwerte",
    fv_sector_ref_body:
      "Die Sektor-KGV-Referenzwerte und DCF-Terminal-Multiplikatoren sind interne Referenzwerte von Stockaily. Sie sind keine live berechneten Sektor-Medianwerte.",
    // AI Opportunity Score
    ais_intro:
      "Der numerische AI Opportunity Score wird deterministisch und regelbasiert berechnet. Generative KI bzw. das LLM berechnet, wählt oder überschreibt den numerischen Score nicht. Der Name folgt unserer Produktterminologie, nicht der Berechnungsmethode.",
    ais_weights_title: "Basisformel",
    ais_weight_valuation: "Fair Value / Auf- oder Abschlag",
    ais_weight_quality: "Geschäftsqualität",
    ais_weight_growth: "Wachstum",
    ais_weight_safety: "Finanzielle Stabilität",
    ais_completeness_note:
      "Geringere Datenvollständigkeit reduziert den resultierenden Score über einen Vertrauens-Multiplikator.",
    ais_guardrails_note:
      "Deterministische Guardrails sowie das Risiko-/Value-Trap-Overlay können den Score deckeln oder das angezeigte Signal bzw. den Status ändern. Dieses Overlay wird nach der Fair-Value-Berechnung angewendet und verändert den angezeigten Fair Value nicht.",
    ais_score_vs_classification:
      "Score und Klassifizierung sind getrennte Ebenen. Der AI Opportunity Score fasst Bewertung, Geschäftsqualität, Wachstum und finanzielle Stabilität zu einem numerischen Ergebnis zusammen. Der finale Status, etwa Opportunity, Neutral oder Risk, wird nicht allein durch den Score bestimmt. Stockaily berücksichtigt zusätzlich den Auf- oder Abschlag zum geschätzten Fair Value, das Aufwärts- oder Abwärtspotenzial, das Risikoniveau, die Datenqualität und deterministische Guardrails. Ein hoher Score allein bedeutet daher noch keine automatische Opportunity- oder Top-Opportunity-Klassifizierung.",
    // Rolle der KI
    ai_deterministic_title: "Deterministisch / modellbasiert",
    ai_deterministic_body:
      "Fair Value, Fair-Value-Spanne, Auf- oder Abschlag, der numerische AI Opportunity Score, KPIs, Risiko-Flags, Signal und Status sind deterministische Modellergebnisse. Sie werden berechnet, bevor eine KI-Erläuterung erzeugt wird, und bleiben verfügbar, wenn die KI-Generierung nicht verfügbar ist.",
    ai_llm_title: "KI-generierte Erläuterung",
    ai_llm_body:
      "KI unterstützt bei Zusammenfassungen, Erklärungen, Bull-/Bear-Cases und weiteren Erläuterungstexten. Die KI-Erläuterung ist auf die übergebenen Modellfakten beschränkt. Konsistenzkontrollen unterdrücken Erläuterungen, die dem deterministischen Fair Value widersprechen würden. Ist die KI-Generierung nicht verfügbar, wird ein deterministischer oder templatebasierter Rückfalltext bereitgestellt.",
    ai_does_not_title: "Was KI nicht leistet",
    ai_does_not_body:
      "KI recherchiert nicht eigenständig Unternehmen, berechnet nicht den Fair Value, berechnet, wählt oder überschreibt nicht den numerischen AI Opportunity Score, berechnet keine deterministischen KPIs und trifft keine Anlageentscheidungen.",
    // Datenquellen
    ds_intro:
      "Jede Analyse enthält strukturierte Metadaten, damit ersichtlich ist, welche Daten verwendet wurden und wie aktuell sie sind.",
    ds_field_data_as_of: "Datenstand",
    ds_field_data_as_of_desc:
      "Referenzzeitpunkt der zugrunde liegenden Fundamentaldaten, die in der Analyse verwendet wurden.",
    ds_field_market_price: "Marktpreis-Stand",
    ds_field_market_price_desc:
      "Zeitstempel des Marktpreises, auf den die Analyse verankert wurde. Marktdaten sind nicht in Echtzeit.",
    ds_field_valuation: "Bewertungs-Stand",
    ds_field_valuation_desc:
      "Zeitpunkt, zu dem der Fair-Value-Mix berechnet wurde.",
    ds_field_generated: "Analyse erzeugt am",
    ds_field_generated_desc:
      "Zeitpunkt, zu dem diese Analyse erstellt wurde.",
    ds_field_quality: "Datenqualitäts-Status",
    ds_field_quality_desc:
      "Gibt an, ob die Analyse aktuelle, veraltete oder teilweise Daten verwendet hat.",
    ds_field_stale: "Veraltete-Daten-Hinweis",
    ds_field_stale_desc:
      "Nennt, welche konkrete Eingabe (Marktpreis, Quartals- oder Jahres-Fundamentals, gecachtes Research) ggf. veraltet ist.",
    ds_field_estimated: "Geschätzte Felder",
    ds_field_estimated_desc:
      "Liste der Felder, deren Wert geschätzt werden musste, weil die Roheingabe fehlte.",
    ds_field_unavailable: "Nicht verfügbare Felder",
    ds_field_unavailable_desc:
      "Liste der Felder, die explizit als nicht verfügbar markiert sind — sie werden nie durch fabrizierte Werte ersetzt.",
    ds_field_provider: "Anbieter-Kategorie",
    ds_field_provider_desc:
      "Ob die Analyse rein deterministisch ist oder mit einem externen KI-Erläuterungs-Anbieter angereichert wurde.",
    ds_field_sources: "Quellen-Kategorien",
    ds_field_sources_desc:
      "Welche Upstream-Kategorien (Marktdaten, Fundamentaldaten, Filings, deterministisches Modell, KI-Erläuterungs-Anbieter) zur Analyse beigetragen haben.",
    ds_no_last_reviewed_note:
      "Es gibt derzeit kein separates Methodik-Änderungsdatum.",
    // Annahmen
    assump_intro:
      "Bestimmte Annahmen sind im Modell fixiert. Andere werden je Analyse anhand der verfügbaren Daten neu berechnet.",
    assump_fixed_title: "Im Code fixiert",
    assump_fixed_dcf_horizon: "Fünfjähriger expliziter DCF-Projektionszeitraum",
    assump_fixed_growth_cap: "Wachstumsrate auf 25 % gedeckelt",
    assump_fixed_discount: "Diskontsatz 8–13 %, modus- und betaabhängig",
    assump_fixed_terminal:
      "Terminal-Multiplikatoren aus einer internen Sektor-Referenztabelle",
    assump_fixed_band:
      "Modusabhängige Unsicherheitsbandbreite (12 % Standard, 20 % Growth, 30 % Speculative) plus bis zu 10 pp Zuschlag bei geringer Datenvollständigkeit",
    assump_fixed_caps:
      "Score-Guardrails (Deckelungen bei 59, 64 und 55) für Extremfälle",
    assump_dynamic_title: "Pro Analyse neu berechnet",
    assump_dynamic_body:
      "Modus, Klassifikation, Sub-Scores, kombinierter Fair Value, Spanne, Auf- oder Abschlag, AI Opportunity Score, Signal, Risikoniveau und Zeithorizont werden für jede Analyse aus den aktuellen Eingaben neu berechnet.",
    assump_missing_title: "Verhalten bei fehlenden Daten",
    assump_missing_body:
      "Fehlende Eingaben werden aus ihren Sub-Scores ausgeschlossen und die Gewichte werden renormalisiert. Werte werden nie stillschweigend auf null gesetzt. Fehlen zentrale Eingaben, wird die Analyse mit einem niedrigeren Datenqualitäts-Status gekennzeichnet.",
    // Konflikte
    conflicts_business_fact_title: "Aktuelle geschäftliche Tatsache",
    conflicts_business_fact_body:
      "Stockaily erhält derzeit weder direkte noch indirekte Vergütung von einem analysierten Unternehmen oder Emittenten dafür, ein Unternehmen oder dessen Wertpapier zur Analyse verfügbar zu machen, es zu analysieren oder hervorzuheben, es zu ranken, es günstig darzustellen oder seinen Fair Value, seinen AI Opportunity Score oder eine andere analytische Ausgabe zu beeinflussen. Es gibt derzeit weder emittentenfinanzierte Berichterstattung noch gesponserte Analysen noch ein vergleichbares Vergütungsmodell.",
    conflicts_maintenance_note:
      "Diese Offenlegung sowie alle betroffenen Transparenz- und Rechtstexte müssen vor der Einführung eines künftigen Emittentenvergütungs-, Sponsoring- oder vergleichbaren Kommerzialisierungsmodells überprüft werden.",
    // Korrekturen
    corrections_intro:
      "Wird eine Analyse wesentlich korrigiert, trägt sie einen kanonischen Korrektur-Status, der hier in der aktuellen Sprache angezeigt wird.",
    corrections_current_state_title: "Aktueller Stand",
    corrections_current_state_body:
      "Korrektur-Metadaten und die entsprechende Anzeige existieren. Es gibt derzeit keinen produktiven redaktionellen Workflow, der Analysen in einen veröffentlichten Korrektur-Status überführt. Die Umsetzung dieses Workflows erfordert weitere Backend- und redaktionelle Arbeiten.",
    // Einschränkungen
    limitations_body:
      "Modellbasierte Schätzungen können unvollständig, unsicher oder fehlerhaft sein. Nichts auf dieser Seite oder in einer Aktienanalyse stellt eine personalisierte Anlageberatung, eine individualisierte Kauf-/Verkauf-/Halte-Anweisung, eine Empfehlung zur Positionsgröße oder eine Garantie für Genauigkeit, Wertentwicklung, Erträge oder Ergebnisse dar.",
    limitations_link_disclaimer: "Vollständigen Finanz-Disclaimer lesen",
  },
  composer: {
    published_title: "Veröffentlichter Snapshot",
    currently_public: "Aktuell öffentlich",
    no_active_fallback_badge: "Statischer Fallback",
    no_active_body:
      "Kein aktiver Homepage-Snapshot. Die öffentliche Startseite nutzt aktuell den statischen Fallback vor dem Launch.",
    published_at: "Veröffentlicht",
    reload: "Neu laden",
    reload_aria: "Veröffentlichten Snapshot und Entwurf neu laden",
    republish: "Letzten erfolgreichen Snapshot erneut veröffentlichen",
    draft_title: "Snapshot-Entwurf",
    draft_not_public_hint:
      "Änderungen am Entwurf werden erst nach der Veröffentlichung öffentlich.",
    updated_at: "Aktualisiert",
    readiness_counter: "{ready}/4 bereit",
    state_empty: "Leer",
    state_partial: "In Bearbeitung",
    state_ready: "Bereit zur Veröffentlichung",
    state_published: "Veröffentlicht",
    slot_label_top_opportunity: "Top-Chance",
    slot_label_opportunity: "Chance",
    slot_label_fairly_valued: "Fair bewertet / Neutral",
    slot_label_risk: "Risiko",
    slot_state_empty: "Leer — Ticker unten festlegen",
    slot_state_valid: "Gültig",
    slot_state_invalid: "Ungültig",
    src_manual_pin: "Manuell festgelegt",
    src_generated: "Automatisch ausgewählt",
    src_inherited: "Vom veröffentlichten Snapshot übernommen",
    chart_available: "Chartdaten verfügbar",
    chart_missing: "Chartdaten fehlen",
    field_status: "Status",
    field_score: "Score",
    field_price: "Kurs",
    field_fair_value: "Fairer Wert",
    invalid_reason_stale_analysis: "Analyse veraltet",
    invalid_reason_classification_mismatch:
      "Klassifizierung passt nicht mehr",
    invalid_reason_chart_series_missing_or_empty: "Chartdaten fehlen",
    invalid_reason_required_fields_missing:
      "Karte hat unvollständige Pflichtfelder",
    invalid_reason_duplicate_ticker_in_draft: "Doppelter Ticker in Slots",
    pin_ticker_label: "Ticker für {slot}",
    pin_action: "Festlegen",
    pin_action_aria: "Ticker in {slot} festlegen",
    generate_remaining: "Verbleibende Slots ergänzen",
    generate_hint:
      "Generieren behält gültige manuelle Festlegungen und füllt nur zulässige verbleibende Slots. Es werden keine fehlenden Karten oder Charts erfunden.",
    publish_now: "Jetzt veröffentlichen",
    publish_disabled_incomplete:
      "Alle vier Slots gültig füllen, bevor veröffentlicht wird.",
    publish_disabled_reload:
      "Aktuellen Entwurf neu laden — der Server sieht ihn nicht als bereit.",
    discard_draft: "Entwurf verwerfen",
    discard_action_aria: "Aktuellen unvollständigen Entwurf verwerfen",
    discard_confirm_title: "Unvollständigen Entwurf verwerfen?",
    discard_confirm_body:
      "Damit wird nur der unvollständige Entwurf entfernt. Der aktuell veröffentlichte Homepage-Snapshot bleibt unverändert.",
    discard_confirm_action: "Entwurf verwerfen",
    cancel: "Abbrechen",
    toast_generate_partial:
      "Entwurf aktualisiert. Es sind noch nicht alle Slots bereit.",
    toast_generate_no_candidate:
      "In den zuletzt verf\u00FCgbaren Analysen wurde keine geeignete Opportunity gefunden.",
    no_eligible_candidate:
      "In den zuletzt verf\u00FCgbaren Analysen wurde keine geeignete Opportunity gefunden.",
    mismatch_warning:
      "Die aktuelle Analyse hat sich von {published} zu {current} ge\u00E4ndert. Die ver\u00F6ffentlichte Karte bleibt unver\u00E4ndert, bis du sie ersetzt und neu ver\u00F6ffentlichst.",
    snapshot_provenance:
      "Beispielanalyse \u00B7 Snapshot ver\u00F6ffentlicht: {date}",
    toast_generate_published:
      "Entwurf war vollständig bereit — auf der Homepage veröffentlicht.",
    toast_publish_success: "Homepage-Snapshot veröffentlicht.",
    toast_already_published:
      "Snapshot war bereits veröffentlicht — keine Änderungen vorgenommen.",
    toast_discard_success:
      "Entwurf verworfen. Veröffentlichter Snapshot unverändert.",
    toast_republish_success:
      "Letzter erfolgreicher Snapshot erneut veröffentlicht. Entwurf bleibt erhalten.",
    announce_pinned: "{ticker} in {slot} festgelegt.",
    announce_generated: "Entwurf durch Generieren aktualisiert.",
    announce_published: "Homepage-Snapshot veröffentlicht.",
    announce_discarded: "Entwurf verworfen.",
    err_load_failed:
      "Fehler beim Laden des Homepage-Snapshots.",
    err_session_expired:
      "Sitzung abgelaufen. Bitte erneut anmelden.",
    err_recent_auth_required:
      "Erneute Anmeldung erforderlich. Bitte bestätigen Sie Ihre Identität, um fortzufahren.",
    err_stale_revision:
      "Der Entwurf wurde anderswo geändert. Er wurde neu geladen — bitte erneut versuchen.",
    err_pin_400:
      "Dieser Ticker kann diesem Slot nicht zugewiesen werden.",
    err_pin_generic: "Festlegen fehlgeschlagen. Bitte erneut versuchen.",
    err_publish_400:
      "Entwurf ist nicht bereit zur Veröffentlichung.",
    err_publish_generic:
      "Veröffentlichung fehlgeschlagen. Bitte erneut versuchen.",
    err_discard_generic:
      "Verwerfen fehlgeschlagen. Bitte erneut versuchen.",
    err_generate: "Generieren fehlgeschlagen. Bitte erneut versuchen.",
    err_republish_generic:
      "Erneute Veröffentlichung fehlgeschlagen. Bitte erneut versuchen.",
    err_busy: "Bitte auf den Abschluss des aktuellen Vorgangs warten.",
  },
  broker_survey: {
    title: "Welche(n) Broker nutzt du?",
    helper: "Mehrfachauswahl möglich.",
    explanation: "Deine Antwort hilft uns, das Onboarding zu verbessern und zukünftige Integrationen zu priorisieren. Stockaily wird dadurch nicht mit deinem Broker verbunden.",
    search_placeholder: "Broker suchen",
    other_label: "Andere",
    other_placeholder: "Welcher Broker?",
    no_broker_label: "Ich nutze noch keinen Broker",
    continue: "Weiter",
    submitting: "Speichert…",
    logout: "Abmelden",
    privacy_link: "Datenschutzerklärung",
    err_required: "Bitte mindestens eine Option auswählen.",
    err_other_required: "Bitte gib den Broker an.",
    err_generic: "Antwort konnte nicht gespeichert werden. Bitte erneut versuchen.",
    err_no_broker_exclusive: "\u201EIch nutze noch keinen Broker\u201C kann nicht mit anderen Optionen kombiniert werden.",
    multi_note: "Mehrfachauswahl — bitte alle tatsächlich genutzten Broker auswählen.",
  },
  early_access: {
    nav_back: "Zurück zu Stockaily",
    seo_title: "Early Access — Stockaily",
    seo_description: "Jetzt zum Stockaily Early Access anmelden. Unternehmenskennzahlen, Bewertung und Risiko werden in drei klaren, modellbasierten Signalen für eine strukturierte Aktienanalyse zusammengeführt. Anmeldung kostenlos — keine Zahlung vor dem Launch.",
    og_title: "Stockaily Early Access",
    og_description: "Unternehmenskennzahlen, Bewertung und Risiko in drei klaren, modellbasierten Signalen für eine strukturierte Aktienanalyse. Anmeldung kostenlos — keine Zahlung vor dem Launch.",
    hero_eyebrow: "Early Access",
    hero_title: "Mit mehr Überzeugung investieren.",
    hero_subtitle: "Stockaily verbindet Unternehmenskennzahlen, Bewertung und Risiko in drei klaren, modellbasierten Signalen für eine strukturierte Aktienanalyse.",
    benefit_opp_title: "Opportunity Score",
    benefit_opp_body: "Ein einziger, erklärbarer Score, der zusammenfasst, wie attraktiv eine Aktie anhand der wichtigsten Fundamentaldaten erscheint.",
    benefit_fv_title: "Fair Value",
    benefit_fv_body: "Eine transparente, modellbasierte Schätzung, was das Unternehmen heute wert ist \u2014 als Kontext, nicht als Empfehlung.",
    benefit_risk_title: "Risiko",
    benefit_risk_body: "Eine verständliche Sicht auf Drawdown-, Konzentrations- und Qualitätsrisiken, die für eine Position strukturell relevant sind.",
    preview_label: "Produktvorschau",
    preview_opp: "Opportunity Score",
    preview_fv: "Fair Value",
    preview_risk: "Risiko",
    preview_opp_value: "Modellbasierte Chancen-Einschätzung",
    preview_fv_value: "Transparente Bewertungs-Einschätzung",
    preview_risk_value: "Strukturierte Risiko-Einschätzung",
    preview_note: "Illustrative Vorschau \u2014 Stockaily zeigt modellbasierte Signale, keine Prognosen, Versprechen oder persönliche Empfehlungen.",
    form_eyebrow: "Sichere dir deinen Platz",
    form_title: "Jetzt für Early Access anmelden.",
    form_subtitle: "Kostenlos. Es wird keine Zahlung vor dem Launch erhoben.",
    form_email_label: "E-Mail-Adresse",
    form_email_placeholder: "du@example.com",
    form_name_label: "Vorname (optional)",
    form_name_placeholder: "Alex",
    form_consent_label: "Ich möchte Early-Access- und Produkt-E-Mails von Stockaily erhalten. Ich kann meine Einwilligung jederzeit widerrufen.",
    form_consent_policy_prefix: "Siehe unsere",
    form_consent_policy_link: "Datenschutzerklärung",
    form_submit: "Zum Early Access anmelden",
    form_submitting: "Wird gesendet\u2026",
    form_err_email_required: "Bitte gib deine E-Mail-Adresse ein.",
    form_err_email_invalid: "Diese E-Mail-Adresse sieht nicht richtig aus.",
    form_err_consent_required: "Bitte setze das Einwilligungs-Häkchen, um fortzufahren.",
    form_err_generic: "Da ist etwas schiefgelaufen. Bitte erneut versuchen.",
    form_success_title: "Bitte prüfe dein Postfach",
    form_success_body: "Falls diese Adresse berechtigt ist, haben wir soeben einen Bestätigungslink geschickt. Öffne ihn, um deine Early-Access-Anmeldung abzuschließen. Der Bestätigungslink ist 7 Tage gültig.",
    offer_text: "Die ersten 100 bestätigten Early-Access-Mitglieder erhalten zum Launch 20 % Founding-Member-Rabatt.",
    offer_fine_print: "Die Anmeldung ist kostenlos. Es wird keine Zahlung vor dem Launch erhoben. Der Rabattcode wird zum Launch per E-Mail versendet.",
    disclaimer: "Stockaily bietet modellbasierte Research-Informationen \u2014 keine persönliche Anlageberatung.",
    legal_privacy: "Datenschutz",
    legal_imprint: "Impressum",
    legal_disclaimer: "Finanz-Disclaimer",
    legal_methodology: "Methodik",
    confirmation_already_title: "Bereits bestätigt",
    confirmation_title: "Du bist bestätigt",
    confirmation_already: "Du bist bereits bestätigt. Wir melden uns per E-Mail, sobald Stockaily startet.",
    confirmation_success: "Du bist bestätigt. Wir melden uns per E-Mail, sobald Stockaily startet.",
  },
};
export default de;

